<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Sales</span>
            <small></small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
              </div>
            </div>
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Customer Name </label>
                  <span style="display: flex;">
                    <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="selectedcustomer" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                    &nbsp;&nbsp;  
                    <button v-if="cust_rights === true" type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Customer" @click="addCustomer()">
                      <i class="fa fa-user"></i>
                    </button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Shop Name </label>
                  <span style="display: flex;">
                    <model-list-select @input="onShpChange($event)" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="select_shop" placeholder="Select Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                    &nbsp;&nbsp;
                    <button v-if="shop_rights === true" type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                </b-form-group>
              </b-col>
              <!-- <b-col sm="2">
                <b-form-group>
                  <label for="name">Category Type</label>
                  <b-form-select v-model="selectedCategoryType" :options="[{value: 'gold', text: 'Gold'}, {value: 'silver', text: 'Silver'}]"></b-form-select>
                </b-form-group>
              </b-col> -->
              <b-col sm="2">
                <b-form-group>
                  <label for="name">Barcode</label>
                  <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" @keyup="checkShop" placeholder="Enter Barcode">&nbsp;&nbsp;
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.barcode}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label for="name">Sale Entry Date</label>
                  <date-picker v-model="saleentry_dt" input-name="date" format="YYYY-MM-DD" editable :not-before="disabledBefore" :not-after="disabledAfter" lang="en" style="width: 0px; min-width: 155px;"></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <h6 class="my-3">
                  Ship To:<small class="printpage"><i class="fa fa-edit" @click.prevent="addressModel =true"></i></small>
                </h6>
                <div><strong>{{ customer1.name }} &nbsp; {{ customer1.phone }}</strong></div>
                <div>{{ customer1.gst }}</div>
                <div>{{ customer1.add }}</div>
                <div>{{ customer1.city }} {{ customer1.state }} {{ customer1.pincode }}</div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header title_head">
            ITEM DETAILS
<!-- improved the style for daily rate display and date -->
<strong>
  <span style="float:right; display: flex; align-items: center; gap: 6px; font-size: 18px;">
    Today's {{ selectedCategoryType === 'gold' ? 'Gold' : selectedCategoryType === 'silver' ? 'Silver' : '' }} Rate:
    <span style="color:black;">
      ₹ {{ charge }}
    </span>
    <span style="font-size: 14px; color:#555;">
      ({{ new Date().toDateString() }})
    </span>
  </span>
</strong>
          </div>
          <div class="card-body" style="padding:0px !important;">
            <table class="table table-striped table-responsive">
              <thead>
                <tr style="font-size: 12px; text-align: center;">
                  <th width="1%">#</th>
                  <th width="14%" style="padding-bottom:20px;">Product Name</th>
                  <th width="6%" style="padding-bottom:20px;" v-if="selectedCategoryType === 'gold'">Carat</th>
                  <th width="6%">Gross weight(gm)</th>
                  <th width="5%" v-if="selectedCategoryType === 'gold'">Stone Weight(gm)</th>
                  <th width="4%">No. of pieces</th>
                  <th width="6%" style="padding-bottom:20px;" v-if="selectedCategoryType === 'gold'">Wastage(gm)</th>
                  <th width="8%" style="padding-bottom:20px;" v-if="selectedCategoryType === 'gold'">Net Weight</th>
                  <th width="9%" style="padding-bottom:20px;" v-if="selectedCategoryType === 'gold'">Stone Price</th>
                  <th width="4%" style="padding-bottom:20px;">Price/gram</th>
                  <th width="6%">Making charges</th>
                  <th width="7%" v-if="is_cs_gst" style="padding-bottom:20px;">SGST %</th>
                  <th width="7%" v-if="is_cs_gst" style="padding-bottom:20px;">CGST %</th>
                  <th width="6%" v-if="is_i_gst" style="padding-bottom:20px;">IGST %</th>
                  <th width="12%" style="padding-bottom:20px;">Total</th>
                  <th width="6%" style="padding-bottom:20px;">Other</th>
                </tr>
              </thead>
              <input type="hidden" name="qty1" id="qty1" value="">
              <tbody id="product_table_body">
                <tr v-for="(row, index) in rows">
                  <td>
                    <a style="font-size:14px;color: #20a8d8; cursor:pointer;" @click="productdisplay(index,row)"><i class="fa fa-plus" v-b-tooltip.hover title="Add New Product"></i></a>
                  </td>
                  <td>
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.product_name" style="width: 100%;" v-on:change="price(index,charge);" disabled>
                    <small style="font-size: 10px;color: darkblue; cursor:pointer;" v-if="row.productExist != ''"> {{row.productExist}}</small>
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.prodct}}</strong></small>
                  </td>
                  <td v-if="selectedCategoryType === 'gold'">
                    <span style="display: flex;">
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.selectcarat" style="width: 100%;" v-on:change="price(index,charge);" disabled>
                    </span>
                  </td>
                  <td>
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.selectweight" style="width: 100%;" v-on:change="price(index,charge);" disabled>
                    <small style="font-size: 10px;color: green;margin-top: 41px;" v-if="row.err_netweight!=''"> {{row.err_netweight}}</small>
                  </td>
                  <td v-if="selectedCategoryType === 'gold'">
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.selectstweight" style="width: 100%;" v-on:change="price(index,charge);" disabled>
                    <small style="font-size: 10px;color: green;margin-top: 41px;" v-if="row.err_netweight!=''"> {{row.err_netweight}}</small>
                  </td>
                  <td>
                    <input type="text" class="form-control-sm" v-model="row.qty" style="width: 100%;" v-on:change="price(index,charge);"><br>
                    <small style="font-size: 10px; color: red;" v-if="row.err_qty!=''">{{row.err_qty}}<br></small>
                    <small style="font-size: 10px;color: green;margin-top: 41px;" v-if="row.avaqty!=''">Qty:{{row.avaqty}}</small>
                  </td>
                  <td v-if="selectedCategoryType === 'gold'">
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.wastage" style="width: 100%;" v-on:change="price(index,charge);">
                    <small style="font-size: 10px; color: red;" v-if="row.err_wastage!=''">{{row.err_wastage}}</small>
                  </td>
                  <td v-if="selectedCategoryType === 'gold'">
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.netweight" style="width: 100%;" v-on:blur="price(index,charge);" disabled>
                  </td>
                  <td v-if="selectedCategoryType === 'gold'">
                    <input type="text" class="form-control-sm" autocomplete="off" v-model="row.stone_price" style="width: 100%;" v-on:change="price(index,charge);">
                    <small style="font-size: 10px;color: green;margin-top: 41px;" v-if="row.stprice!=''">Price:{{row.stprice}}</small>
                    <small style="font-size: 10px; color: red;" v-if="row.err_stone_price!=''">{{row.err_stone_price}}</small>
                  </td>
                  <td>
                    <span>
                      <input type="text" style="width: 100%;" v-model="row.price" class="form-control-sm" v-on:change="price(index,charge);">
                    </span>
                  </td>
                  <td>
                    <span>
                      <input type="text" style="width: 100%;" autocomplete="off" v-model="row.making_charges" class="form-control-sm" v-on:change="price(index,charge);">
                    </span>
                    <small style="font-size: 10px; color: red;" v-if="row.err_making_charges!=''">{{row.err_making_charges}}<br></small>
                  </td>
                  <td v-show="is_cs_gst">
                    <input type="text" style="width: 100%;" v-on:change="price(index,charge);" v-model="row.sgst" class="form-control-sm">
                    <small style="font-size: 10px; color: red;" v-if="row.err_sgst!=''">{{row.err_sgst}}<br></small>
                  </td>
                  <td v-show="is_cs_gst">
                    <input type="text" style="width: 100%;" autocomplete="off" class="form-control-sm" v-model="row.cgst" v-on:change="price(index,charge);">
                    <small style="font-size: 10px; color: red;" v-if="row.err_cgst!=''">{{row.err_cgst}}<br></small>
                  </td>
                  <td v-show="is_i_gst">
                    <input type="text" style="width: 100%;" autocomplete="off" class="form-control-sm" v-model="row.igst" v-on:change="price(index,charge);">
                    <small style="font-size: 10px; color: red;" v-if="row.err_igst!=''">{{row.err_igst}}<br></small>
                  </td>
                  <td>
                    <input type="text" disabled="disabled" v-model="row.amttotal" style="width: 100%;" class="form-control-sm" v-on:change="price(index,charge);">
                  </td>
                  <td>
                    <center>
                      <i class="fa fa-reorder" style="color: #20a8d8;" v-b-tooltip.hover title="Add More option" variant="secondary" @click="openmodal(index)"></i>
                      <i class="fa fa-trash-o" style="color: #F44336;" v-b-tooltip.hover title="Delete" v-on:click="removeElement(index);"></i>
                    </center>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div style="font-size: 13px;color: green;">Add New Row:
                      <span style="cursor: pointer;" @click="addRow1" class="badge badge-pill badge-info" v-b-tooltip.hover title="Add New Row">Add</span>
                    </div>
                  </td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    Total Amount Before Tax: <input type="text" :value="totalamt" class="form-control-sm" disabled>
                  </td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:25px;">Additional Discount:</span>
                    <input type="text" v-on:change="discountadd" class="form-control-sm" v-model="detail.addition">
                  </td>
                </tr>
                <tr v-if="is_cs_gst">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:115px;">SGST:</span>
                    <input type="text" class="form-control-sm" disabled :value="totalsgst">
                  </td>
                </tr>
                <tr v-if="is_cs_gst">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:115px;">CGST:</span>
                    <input type="text" class="form-control-sm" disabled :value="totalcgst">
                  </td>
                </tr>
                <tr v-if="is_i_gst">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:120px;">IGST:</span>
                    <input type="text" class="form-control-sm" disabled :value="totaligst">
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: left;">Payment:</td>
                  <td colspan="2" style="text-align: left;">
                    <b-form-select v-model="selected_pytype" :options="lst_paymenttype" v-on:change="paychange"></b-form-select>
                  </td>
                  <td :colspan="selectedCategoryType === 'gold' ? 13 : 8" style="text-align: right;">
                    <span style="margin-right:47px;">Total Tax Amount:</span>
                    <input type="text" :value="totaltax" disabled class="form-control-sm">
                  </td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: left;">
                    <b-form-group label="">
                      Payment Mode:
                      <b-form-radio v-model="selected_pymode" name="payment_mode" value="cash" v-on:change="modechange">Cash</b-form-radio>
                      <b-form-radio v-model="selected_pymode" name="payment_mode" value="cheque" v-on:change="modechange">Cheque</b-form-radio>
                    </b-form-group>
                  </td>
                  <td :colspan="selectedCategoryType === 'gold' ? 13 : 8" style="text-align: right;">
                    <span style="margin-right:23px;">Total Amount To Pay:</span>
                    <input type="text" :value="totalamtpay" disabled class="form-control-sm"><br>
                    <small style="font-size: 10px; color: red;" v-if="err_totamtpay != ''">{{err_totamtpay}}</small>
                  </td>
                </tr>
                <tr v-if="fullpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:41px;">Amount Received:</span>
                    <input type="text" v-on:change="calchnge();" class="form-control-sm" v-model="totalamtreceived"><br>
                    <small style="font-size: 10px; color: red;" v-if="amt_rec != ''">{{amt_rec}}</small>
                  </td>
                </tr>
                <tr v-if="fullpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:102px;">Change:</span>
                    <input type="text" class="form-control-sm" disabled v-model="chng">
                  </td>
                </tr>
                <tr v-if="parpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:39px;">Amount Received:</span>
                    <input type="text" class="form-control-sm" v-model="totalparamtreceived" v-on:change="calbalance();"><br>
                    <small style="font-size: 10px; color: red;" v-if="amt_rec != ''">{{amt_rec}}</small>
                  </td>
                </tr>
                <tr v-if="parpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:103px;">Balance:</span>
                    <input type="text" class="form-control-sm" disabled v-model="bal">
                  </td>
                </tr>
                <tr v-if="chqpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:79px;">Cheque No.:</span>
                    <input type="text" name="cheque_no" autocomplete="off" v-model="cheque_no" class="form-control-sm" placeholder="Enter Cheque No">
                  </td>
                </tr>
                <tr v-if="chqpay === true">
                  <td colspan="2"></td>
                  <td :colspan="selectedCategoryType === 'gold' ? 15 : 10" style="text-align: right;">
                    <span style="margin-right:23px;">Cheque Date.:</span>
                    <date-picker v-model="cheque_date" editable lang="en" class="form-control-sm"></date-picker>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-modal title="Add More Option" no-close-on-esc no-close-on-backdrop v-model="largeModal" hide-footer @ok="largeModal = false">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Discount Percentage:</label>
                    <input type="text" class="form-control" name="cmp_phone" v-model="percentagemd" placeholder="Enter Discount Percentage">
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.dis}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Discount Amount :</label>
                    <input type="text" class="form-control" id="cmp_email" v-model="amtmd" name="cmp_email" placeholder="Enter Discount Amount">
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.amt}}</strong></small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Tax Inclusive:</label>
                    <input type="checkbox" name="cmp_inclusive" v-model="inclusive">
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.inclusive}}</strong></small>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-sm btn-primary" @click="savemodal(indexval)">
                <i class="fa fa-dot-circle-o"></i> Save this
              </button>
            </b-modal>
          </div>
          <div class="card-footer">
            <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit('')"><i class="fa fa-dot-circle-o"></i> Save</button>&nbsp;&nbsp;&nbsp;&nbsp;
            <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit('inv')"><i class="fa fa-dot-circle-o"></i> Save And Generate Invoice</button>
          </div>
        </div>
      </div>
    </div>
    <b-modal title="Shipping Details" hide-footer size="lg" v-model="addressModel" @ok="addressModel = false">
      <div class="row" v-for="(address1, index) in addr">
        <div class="col-sm-10">
          <div class="form-group">
            <b>{{address1.yname}}&nbsp;({{address1.yphn}})</b><br>
            <b>{{address1.ygst}}</b><br>
            <span v-if="address1.yaddress!=''">{{address1.yaddress}}<br></span>
            <span v-if="address1.ystate != '' && address1.ycity != '' && address1.ypincode != ''">
              {{address1.ystate}} &nbsp; {{address1.ycity}} - {{address1.ypincode}}
            </span>
          </div>
        </div>
        <div class="col-sm-2" style="color:#f86c6b;font-size: 20px; cursor: pointer;">
          <span>
            <small><i @click="showAddress(address1)" class="fa fa-plus" style="color:#34a8d8;cursor:pointer;">Add</i></small>
          </span>
        </div>
        <hr width="97%">
      </div>
    </b-modal>
    <b-modal title="Plan Limit Reached" size="sm" class="modal-warning" ok-only v-model="plan_modal">
      <b-row>
        <b-col sm="2">
          <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
        </b-col>
        <b-col sm="10">
          <b-row><b>You have hit the plan limit.</b></b-row>
          <b-row>You have reached the limit of adding Customers. Please upgrade your plan to add more Customers.</b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal title="Plan Limit Reached" size="sm" class="modal-warning" ok-only v-model="shopplan_modal">
      <b-row>
        <b-col sm="2">
          <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
        </b-col>
        <b-col sm="10">
          <b-row><b>You have hit the plan limit.</b></b-row>
          <b-row>You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.</b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal title="Plan Limit Reached" size="sm" class="modal-warning" ok-only v-model="prodplan_modal">
      <b-row>
        <b-col sm="2">
          <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
        </b-col>
        <b-col sm="10">
          <b-row><b>You have hit the plan limit.</b></b-row>
          <b-row>You have reached the limit of adding Product. Please upgrade your plan to add more Products.</b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal title="Are You Sure?" size="sm" class="modal-warning" v-model="shopchange_modal" ok-variant="danger" ok-title="Yes" @ok="handleOk" @cancel="handleCancel" no-close-on-esc no-close-on-backdrop>
      <b-row>
        <b-col sm="2">
          <i class="fa fa-exclamation" style="font-size: 40px; color: red;"></i>
        </b-col>
        <b-col sm="10">
          <b-row><b>Are you Sure, You want to Change the Shop?</b></b-row>
          <b-row>Once you change the shop, all the Items entered by you will be cleared. Do you still want to continue?</b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal title="Product Display" no-close-on-esc no-close-on-backdr
op size="lg" hide-footer class="modal-info" v-model="largeModal2">
      <b-row>
        <div class="col-sm-4">
          <div class="form-group">
            <label>Product Name</label>
            <model-list-select :list="productnamexx" option-value="product_id" option-text="product_name" v-model="selectproductrow1" placeholder="Find Product Name" @input="onSelectprd($event,index)" @searchchange="searchprd4($event,index)" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" class="product-drop"></model-list-select>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label>Select Product Sl no.</label>
            <span>
              <model-list-select :list="products_list" option-value="id" option-text="id" v-model="selectid" placeholder="select" @input="onselectlist($event,index)" @searchchange="searchlist($event,index)" style="white-space: nowrap; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important; border: 1px solid rgb(194, 207, 214); min-height: 35px;" class="list-drop"></model-list-select>
              &nbsp;&nbsp;
            </span>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label>Price</label>
            <input type="text" style="width: 100%;" v-model="price1" class="form-control-sm" disabled>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-sm-4" v-if="selectedCategoryType === 'gold'">
          <div class="form-group">
            <label>Carat</label>
            <input type="text" class="form-control-sm" autocomplete="off" v-model="carat_value1" style="width: 100%;" disabled>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label>Weight</label>
            <input type="text" class="form-control-sm" autocomplete="off" v-model="weight1" style="width: 100%;" disabled>
          </div>
        </div>
        <div class="col-sm-4" v-if="selectedCategoryType === 'gold'">
          <div class="form-group">
            <label>Stone Weight</label>
            <input type="text" style="width: 100%;" v-model="stone_weight1" class="form-control-sm" disabled>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-sm-4">
          <div class="form-group">
            <label>Available Quantity</label>
            <input type="text" class="form-control-sm" autocomplete="off" v-model="available_qty" style="width: 100%;" disabled>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-sm-4">
          <button type="submit" class="btn btn-sm btn-primary label_bttn" @click="saveModalData(index)">Save</button>
          <Spinner v-if="loading"></Spinner>
        </div>
      </b-row>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
  import Spinner from '../../spinner.vue'
  import DatePicker from 'vue2-datepicker'
  // import Modal from '../../plugin.js'
  export default {
    components: {
      'date-picker':  DatePicker,
      Spinner
    },
    data () {
      return {
        silverInputMode: 'price', // Default to price for silver
        matchingCategories: [],
        shop_option:null,
        selectedCategoryType: null,
        isDropdownDisabled: false, 
        plan_modal:false,
        shopplan_modal:false,
        shopchange_modal:false,
        prodplan_modal:false,
        disabledBefore: null,
        disabledAfter: null,
        csgstdisable:true,
        igstdisable:true,
        addr:[],
        addressModel:false,
        saleentry_dt: new Date().toISOString().slice(0,10),
        saleprice_nonedit:true,
        validate:1,
        amt_rec: '',
        err_totamtpay:'',
        loading:false,
        variantindex:null,
        smallmodal:false,
        fullpay:true,
        chqpay:false,
        parpay:false,
        chng:0,
        bal:0,
        temp:[],
        tempres:[],
        totalamtreceived:'',
        totalparamtreceived:'',
        cheque_no:'',
        cheque_date:'',
        variantvalue:[],
        tempArr:[],
        caratval:[],
        stweightlist:[],
        selectstweight:[],
        stprice:'',
        weightlist:[],
        selectweight:null,
        selectcarat:null,
        making_charges:'',
        available_qty:'',
        weight:'',
        data_selected:true,
        wastage:'',
        netweight:'',
        charge:'',
        selectweightt:null,
        stone_weight:'',
        stone_price:'',
        err_stone_price:'',
        err_stone_weight:'',
        err_selectcarat:'',
        category_id:'',
        variantdata:null,
        oldshp:null,
        percentagemd:'',
        amtmd:'',
        barcode:'',
        inclusive:false,
        indexval:null,
        largeModal:false,
        customername:[],
        selected_pytype:'full',
        lst_paymenttype:[
        { value: 'full', text: 'Full' },
        { value: 'partial', text: 'Partial' },
        { value: 'no', text: 'No' },
        ],
        selected_pymode:'cash',
        selectedcustomer:null,
        shopname:[],
        selectshop:null,
        select_shop:null,
        saleprice_editable:false,
        processedRow:null,
        productname:[],
        // lst_prod_var:[],
        selectproduct:{},
        is_cs_gst:true,
        largeModal2:false,
        stone_weight1:'',
        carat_value1:'',
        weight1:'',
        price1:'',
        tempprice:'',
        selectproductrow1:null,
        productnamexx:[],
        purchase_prc:'',
        products_list:[],
        selectid:null,
        is_i_gst:true,
        company_gst:null,
        customer_gst:null,
        rows:[],
        haserror:{
          amt:'',
          dis:'',
          cust:'',
          message:'',
          inclusive:'',
          shop:''
        },
        customer1: {
          name: null,
          add: null,
          city: null,
          state: null,
          pincode: null,
          phone: null,
          gst:null,
          ship_id:null
        },
        detail:{
          totprddis:'',
          addition:'',
          tot:'',
          cgst:'0.00',
          sgst:0.00,
          igst:0.00,
          taxamt:0,
          totalamtpay:0,
          totalamtpendingpay:'',
        }
      }
    },
mounted() {
  const type = (this.$route.params.type || 'gold').toLowerCase(); // Fallback to 'gold'
  this.selectedCategoryType = type;
  this.daily_goldprice();
  this.daily_silverprice();
  this.categorylist("comp");
},
    computed: {
      cust_rights: function(){
        return this.$store.getters.get_cust_rights
      },
      shop_rights: function(){
        return this.$store.getters.get_shop_rights
      },


    


      totaldis() {

        var all =this.rows.reduce((total,row) => {
          if(Number(row.amtmd1)==0){
            return total +  (Number(row.qty)*Number(row.price)*Number(row.percentagemd1))/100;
          }else{
            return total +  (Number(row.amtmd1));
          }
        }, 0);
        all = all.toFixed(3);
        this.detail.totprddis=all;
        return all;
      },
     

        totalamt() {
        var all =this.rows.reduce((total,row) => {
          return total +  Number(row.amt);
          console.log(total +  Number(row.amt))
        }, 0);
        all = all.toFixed(3);
        this.detail.tot=all;
        return all;
      },

      totalcgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.cgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(3);
        this.detail.cgst=all;
        return all;
      },
      totalsgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.sgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(3);
        this.detail.sgst=all;
        return all;
      },
      totaligst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.igst)*Number(row.amt))/100);
       }, 0);
        all = all.toFixed(3);
        this.detail.igst=all;
        return all;
      },
      totaltax() {
        var all =this.rows.reduce((total,row) => {
         return total + ((Number(row.cgst)*Number(row.amt))/100)+ ((Number(row.sgst)*Number(row.amt))/100)+ ((Number(row.igst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(3);
        this.detail.taxamt=all;
        return all;
      },
      totalamtpay(){
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal));
        }, 0);
        all = all.toFixed(3);
        if(this.detail.addition==''){
          this.detail.totalamtpay=all;
          return all
        }else{
          this.detail.totalamtpay=all-parseFloat(this.detail.addition);
          return (all-parseFloat(this.detail.addition)).toFixed(3);
        }
      }
    },

    created(){
      for (var i = 0; i <3; i++) {
       this.rows.push({ caratval:[],selectcarat:null,productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,stweightlist:[],selectstweight:null,weightlist:[],selectweight:null,price:'', qty:'',amt:'', cgst:0.00, sgst:0.00,igst:0.00,amttotal:0,percentagemd1:'',making_charges:'',weight:'',netweight:'',wastage:'',stone_price:'',stone_weight:'',err_stone_weight:'',err_stone_price:'',err_selectcarat:'',amtmd1:'',variantrow:'n/a',avaqty:'',stprice:'',show:false,priceqty:'', inclusive1:false, err_qty:'', err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',show1:false,show2:false})
      }
      this.searchshops();
      this.searchcustomer();
      this.shopuser();

      //this.searchcaratval();
   

      //  this.disabledBefore
      //  this.disabledAfter
      var current_dt = new Date()
      var before_180 = new Date(current_dt.valueOf())
      var after_180 = new Date(current_dt.valueOf())
      before_180.setDate(before_180.getDate() - 180)
      after_180.setDate(before_180.getDate() + 180)
      this.disabledBefore = before_180
      this.disabledAfter = after_180
      
    },

    methods:{
      handleOk(event){
        // Prevent modal from closing
        this.shopchange_modal = false;
        event.preventDefault();
        // Trigger submit handler
        this.onSelectShp();
      },
      isCaratSelected(selectcarat) {
   return this.row.selectcarat
    },
    
      
      handleCancel(event){
        event.preventDefault();
        this.shopchange_modal = false;
        this.select_shop = this.selectshop;
      },
      
      addProduct(row,index) {
         var _thiss = this
        this.loading = true;
        this.$http.get('/api/companyproducts/chk_plan_count').then(function(response){
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
              _thiss.plan_modal=false
              if(_thiss.selectedcustomer==null || _thiss.selectedcustomer.customer_id === undefined){
                _thiss.haserror.cust="Please Select Customer"
              }
              else{
                var _this = _thiss
                row['productnamex'] = []
                row['selectproductrow'] = null
                _thiss.haserror.cust=""
                _thiss.$http.get('/api/companyproducts/loadData').then(function (response){
                  if(response.data.data){
                    console.log(response.data)
                    _this.$addproductmodal.show(response.data.data);
                    var __this = _this
                    var timer = setInterval(function(){
                    var modal_return = __this.$store.getters.get_productmodal;
                    if(modal_return !== null){
                      clearInterval(timer);
                    }
                  }, 1000);
                  }
                }).catch(function(error){
                  console.log(error)
                  if (error.response.status === 401) {
                    localStorage.clear();
                    _this.$store.commit('SET_AUTH_USER', null)
                    _this.$router.push('/');
                  }
                  if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
                    localStorage.clear();
                    _this.$store.commit('SET_AUTH_USER', null)
                    _this.$router.push('/');
                  }
                });
              }
            }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
      },
      
      
      
saveModalData(index) {
  if (index === null) return;
  var _this = this;

  console.log(`[SaveModalData][Row ${index}] Initializing row for category: ${this.selectedCategoryType}`);

  const isSilver = this.selectedCategoryType === 'silver';
  const selected = this.selectid || {};

  // --- Base product info ---
  _this.rows[index].selectproductrow = this.selectproductrow1;
  _this.rows[index].product_name = this.selectproductrow1.product_name || '';
  _this.rows[index].productnamex = this.productnamexx || '';

  // --- Category & selection info ---
  _this.rows[index]['category'] = this.selectedCategoryType;
  _this.rows[index]['selectid'] = selected.id || '';
  _this.rows[index]['selectcarat'] = isSilver ? 0 : (selected.carat || selected.carat_value || 0);
  _this.rows[index]['selectweight'] = selected.weight || '';
  _this.rows[index]['selectstweight'] = selected.stweight || selected.stone_weight || '';
  _this.rows[index]['avaqty'] = selected.quantity || 0;

  // --- Pricing and weights ---
  _this.rows[index]['wastage'] = isSilver ? 0 : (selected.wastage || parseFloat(0).toFixed(2));
  _this.rows[index]['making_charges'] = selected.making_charges || parseFloat(0).toFixed(2);
  _this.rows[index]['stone_price'] = selected.stone_price || parseFloat(0).toFixed(2);
  _this.rows[index]['stprice'] = selected.stone_price || 0;
  _this.rows[index]['qty'] = 1;

  // --- Purchase price (from backend) ---
  _this.purchase_prc = selected.product_unit_cost || 0;

  // --- Initialize base price ---
_this.rows[index]['price'] = this.selectedCategoryType === 'silver' ? (this.charge ? parseFloat(this.charge).toFixed(2) : '0.00') : '0.00';


   _this.carat_price(index);
   _this.price(index, this.charge);
   this.show_tax(this.rows[index], index);
  console.log(`[SaveModalData][Row ${index}] Final Row Data:`, _this.rows[index]);
  _this.largeModal2 = false;
},


      productdisplay(index,row)
      {
      this.index = index
      console.log(index)
      this.price1= this.rows[index].product_unit_cost;
      this.selectproductrow1= this.rows[index].selectproductrow;
      this.selectweightt = this.rows[index].selectweightt;
      console.log(this.rows[index].selectproductrow)
      this.largeModal2 = true
       
      },


      addCustomer(){
        var _thiss = this
        this.loading = true;
        this.$http.get('/api/customers/chk_plan_count').then(function(response){
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
               var params = {}
               var country_id = '101';
               var state_id = '22';
               var city_id = '2707';
               var _this = _thiss
                _this.$http.get('/api/countries').then(function(countries){
                  params["conopt"] = countries.data;
                  // var __this = _this
                  _this.$http.get('/api/companytypes').then(function(response){
                      params["contyp"] = response.data;
                      // var _tthis = __this
                      _this.$http.get('/api/countries/'+country_id).then(function(sel_con){
                        params["con"] = sel_con.data
                        _this.$http.get('/api/states?&filter[where][country_id]='+country_id).then(function(stateopt){
                          params["stateopt"] = stateopt.data;
                          _this.$http.get('/api/states/'+state_id).then(function(sel_state){
                            params["state"] = sel_state.data
                           _this.$http.get('/api/cities?filter[where][state_id]='+state_id).then(function(cityopt){
                             params["cityopt"] = cityopt.data;
                            _this.$http.get('/api/cities/'+city_id).then(function(sel_city){
                                params["city"] = sel_city.data
                                _this.$addcustomermodal.showCustomer(params);
                                // var ___this = _tthis
                                var timer = setInterval(function(){
                                var modal_return = _this.$store.getters.get_custmodal;
                                if(modal_return !== null){
                                  // __this.selectshop = modal_return  
                                  _this.customername.push(modal_return)
                                  _this.selectedcustomer = modal_return
                                  _this.onSelectCust(modal_return)
                                  clearInterval(timer);
                                }
                              }, 1000);
                             }).catch(function(error){
                              console.log(error)
                            })
                            }).catch(function(error){
                            console.log(error)
                          })
                          }).catch(function(error){
                          console.log(error)
                          });
                        }).catch(function(error){
                        console.log(error)
                        });
                      }).catch(function(error){
                        console.log(error)
                      });
                  }).catch(function(err){
                    console.log(err)
                  });
                }).catch(function(error){
                  console.log(error)
                });
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
       
      },
      showAddress(adrs){
        this.customer_gst = null
        this.customer1.name = adrs.yname
        this.customer1.add = adrs.yaddress
        this.customer1.city = adrs.ycity
        this.customer1.phone = adrs.yphn
        this.customer1.state = adrs.ystate
        this.customer1.pincode = adrs.ypincode
        this.customer1.gst = adrs.ygst
        this.customer1.ship_id = adrs.chkship_id
        this.addressModel = false
        this.is_cs_gst = true
        this.is_i_gst = true
        this.customer_gst=this.customer1.gst
        // if(this.customer1.gst !== undefined){
        //   this.haserror.cust=''
        //   this.customer_gst=this.customer1.gst
        // }
       

        if(this.rows.length > 0){
          this.set_taxforall()
           for (var i = 0; i < this.rows.length; i++) {
             if(this.rows[i].selectproductrow != null){
               if(this.rows[i].selectproductrow.tax_gst_id)
                 this.show_tax(this.rows[i],i)
             }
           }
        }
      },
carat_price(index) {
  console.log(`[Carat Price][Row ${index}] Category: ${this.selectedCategoryType}, Charge: ${this.charge}`);
  
  if (!this.charge || isNaN(this.charge) || this.charge <= 0) {
    console.warn(`[Carat Price][Row ${index}] Invalid charge value: ${this.charge}. Setting price to 0.`);
    this.rows[index]['price'] = '0.00';
    return;
  }

  if (this.selectedCategoryType === 'silver') {
    this.rows[index]['price'] = parseFloat(this.charge).toFixed(2);
    console.log(`[Carat Price][Row ${index}] Silver price set: ${this.rows[index]['price']}`);
    return;
  }

  // Gold-specific logic
  const carat = this.rows[index].selectcarat;
  if (!carat || isNaN(carat) || carat <= 0) {
    this.rows[index]['price'] = parseFloat(this.charge / 10).toFixed(2);
    console.log(`[Carat Price][Row ${index}] Invalid or zero carat. Setting base price: ${this.rows[index]['price']}`);
    return;
  }

  let price;
  switch (parseInt(carat)) {
    case 24:
      price = ((100 * this.charge) / 100) / 10;
      break;
    case 22:
      price = ((91.60 * this.charge) / 100) / 10;
      break;
    case 21:
      price = ((87.5 * this.charge) / 100) / 10;
      break;
    case 20:
      price = ((83.3 * this.charge) / 100) / 10;
      break;
    case 18:
      price = ((75 * this.charge) / 100) / 10;
      break;
    case 15: 
      price = ((62.5 * this.charge) / 100) / 10;
      break;
    case 14:
      price = ((58.3 * this.charge) / 100) / 10;
      break;
    case 12:
      price = ((50 * this.charge) / 100) / 10;
      break;
    case 10:
      price = ((41.6 * this.charge) / 100) / 10;
      break;
    case 9:
      price = ((37.5 * this.charge) / 100) / 10;
      break;
    case 8:
      price = ((33.3 * this.charge) / 100) / 10;
      break;
    case 6:
      price = ((25 * this.charge) / 100) / 10;
      break;
    default:
      price = this.charge / 10;
  }
  this.rows[index]['price'] = parseFloat(price).toFixed(2);
  console.log(`[Carat Price][Row ${index}] Gold price set for carat ${carat}: ${this.rows[index]['price']}`);
},

    company_data(){
        this.company_gst = this.selectshop.shop_gst
      },


      set_taxforall(){
        console.log("in set tax for all")
        var lst_tax_id = [];
        for(var i=0; i<this.rows.length;i++){
          if(this.rows[i].selectproductrow !== null){
            var tax_id = typeof this.rows[i].selectproductrow === 'object' ? this.rows[i].selectproductrow.tax_gst_id : this.rows[i].productdetails[0].tax_gst_id
            lst_tax_id.push(tax_id)
          }
        }
        if(lst_tax_id.length > 0){
          var _this = this
        this.$http.get('/api/taxrates?filter={"where": {"tax_id": {"inq": ["'+ lst_tax_id.join('","') +'"]}}}').then(function(response){
          if(response.data.length > 0){
            var obj = {}
            for(var j=0;j<response.data.length;j++){
              obj[response.data[j].tax_id] = response.data[j]
            }
            
            if(_this.company_gst && _this.customer_gst){
              console.log("in if")
              var company_gst = _this.company_gst.substring(0, 2)
              var customer_gst = _this.customer_gst.substring(0, 2)
              console.log('the company gst is:', company_gst)
              console.log('the customer gst is:', customer_gst)
              if(company_gst === customer_gst){
                console.log("GSt matched")
                for(var k=0;k<_this.rows.length;k++){
                   if(_this.rows[k].selectproductrow !== null){
                    var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                    _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst']
                    _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst']
                    _this.rows[k]['igst'] = 0.00
                   }
                }
                _this.detail.igst = 0.00
              }else{
                console.log("gst did not match")
                for(var k=0;k<_this.rows.length;k++){
                   if(_this.rows[k].selectproductrow !== null){
                      var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                      _this.rows[k]['cgst'] = 0.00
                      _this.rows[k]['sgst'] = 0.00
                      _this.rows[k]['igst'] = obj[tax_id]['tax_igst']
                   }
                }
                _this.detail.sgst = 0.00
                _this.detail.cgst = 0.00
              }
            }else if(!_this.company_gst){
               for(var k=0;k<_this.rows.length;k++){
                 if(_this.rows[k].selectproductrow !== null){
                  _this.rows[k]['inclusive1'] = true
                  _this.rows[k]['cgst'] = 0.00
                  _this.rows[k]['sgst'] = 0.00
                  _this.rows[k]['igst'] = 0.00
                 }
              }
              _this.detail.cgst = 0.00
              _this.detail.sgst = 0.00
              _this.detail.igst = 0.00
              // _this.rows[index]['cgst'] = 0.00
              // _this.rows[index]['sgst'] = 0.00
              // _this.rows[index]['igst'] = 0.00
            }else{
               for(var k=0;k<_this.rows.length;k++){
                 if(_this.rows[k].selectproductrow !== null){
                  var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                  _this.rows[k]['inclusive1'] = false
                  _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst']
                  _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst']
                  _this.rows[k]['igst'] = 0.00
                 }
              }
              
              _this.detail.igst = 0.00
               _this.rows[index]['cgst'] = response.data.tax_cgst 
               _this.rows[index]['sgst'] = response.data.tax_sgst
               _this.rows[index]['igst'] = 0.00
            }

            for(var k=0;k<_this.rows.length;k++){
              if(_this.rows[k].selectproductrow !== null){
                _this.price(k)
              }
            }
             _this.price(index,charge)
          } 
          else{
            alert('Something went wrong')
          }
        }).catch(function(err){
          console.log(err)
        });
        }
      },

      
daily_goldprice(index, charge) {
  var _this = this;
  this.$http.get('/api/goldprices/getdetails').then(function (response) {
    console.log(response.data);
    console.log('selected category type is:', _this.selectedCategoryType);
    if (_this.selectedCategoryType && _this.selectedCategoryType === 'gold') { // Check if defined
      _this.charge = response.data[0].gold_rate;
      console.log(_this.charge);
    }
  }).catch(function (err) {
    console.log(err);
  });
},


daily_silverprice(index, charge) {
  var _this = this;
  this.$http.get('/api/silverprices/getdetails').then(function (response) {
    console.log(response.data);
    console.log('selected category type is:', _this.selectedCategoryType);
    if (_this.selectedCategoryType && _this.selectedCategoryType === 'silver') { // Check if defined
      _this.charge = response.data[0].per_gram;
      console.log(_this.charge);
    }
  }).catch(function (err) {
    console.log(err);
  });
},


   categorylist(val) {
      if (val === "comp") {
        if (!this.clf_time) {
          this.clf_time = true;
        } else {
          return;
        }
      }
      this.$http
        .get("/api/categories")
        .then((response) => {
          this.categoryopt = response.data;
          const type = (this.$route.params.type || '').toLowerCase();
          console.log('Purchase type:', type);
          this.selectedCategoryType = type;
          console.log('selected category type:', this.selectedCategoryType);
          if (type === 'gold' || type === 'silver') {
            this.matchingCategories = this.categoryopt
              .filter(cat => cat.category_type && cat.category_type.toLowerCase() === type)
              .map(cat => cat.category_id);
            console.log('Matching category IDs:', this.matchingCategories);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

      
      
      addShop(){
        var _this=this
        this.loading = true;
        this.$http.get('/api/shopestablishments/chk_plan_count').then(function(response){
          // console.log(response.data.message)
          _this.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _this.shopplan_modal = true
            }
            else{
               _this.shopplan_modal = false
              var params = {}
              _this.$http.get('/api/countries').then(function(countries){
                params['countries'] = countries.data
                _this.$addshopmodal.showShop(params);
                var __this = _this
                var timer = setInterval(function(){
                var modal_return = __this.$store.getters.get_shopmodal;
                if(modal_return !== null){
                      // __this.selectshop = modal_return  
                      __this.searchshops(modal_return)
                      clearInterval(timer);
                    }
                  }, 1000);
              }).catch(function(error){
                console.log(error)
              });
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
        
    },

    calchnge(){
      var regexp = /^[1-9]\d*(\.\d+)?$/
      if(this.totalamtreceived !== ''){
        if(regexp.test(this.totalamtreceived) === false){
          alert('Please Enter Valid Amount')
          this.totalamtreceived = ''
          return
        }else{
          this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(3)
        }
      } 
    },

    calbalance(){
      var regexp = /^[1-9]\d*(\.\d+)?$/
      if(this.totalparamtreceived !== ''){
        if(regexp.test(this.totalparamtreceived) === false){
          alert('Please Enter Valid Amount')
          this.totalparamtreceived = ''   
          return
        }else{
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
        }
      }
    },

    paychange(select_paytype_val){
      this.selected_pytype = select_paytype_val
      this.fullpay = false
      this.parpay = false
      if(this.selected_pytype === 'full'){
        this.fullpay = true
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
          this.chqpay = false
        }
      }
      else if(this.selected_pytype === 'partial'){
        this.parpay = true
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
          this.chqpay = false
        }
      }
      else{
        this.chqpay = false
      }
    },
    modechange(select_paymode_val){
      this.selected_pymode = select_paymode_val
      if(this.selected_pytype !== 'no'){
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
         this.chqpay = false 
       }
     }
     else{
      this.chqpay = false 
    }
  },

  checkVariant(){
    if(this.variantdata == null){
      this.rows[this.variantindex].productnamex=[]
      this.rows[this.variantindex].selectedproductid=null
      this.rows[this.variantindex].unit=''
      this.rows[this.variantindex].selectproductrow=null
      this.rows[this.variantindex].price=0
      this.rows[this.variantindex].qty=''
      this.rows[this.variantindex].amt=''
      this.rows[this.variantindex].cgst=0.00
      this.rows[this.variantindex].sgst=0.00
      this.rows[this.variantindex].igst=0.00
      this.rows[this.variantindex].amttotal=0
      this.rows[this.variantindex].percentagemd1=''
      this.rows[this.variantindex].amtmd1=''
      this.rows[this.variantindex].variantrow='n/a'
      this.rows[this.variantindex].avaqty=''
      this.rows[this.variantindex].show=false
      this.rows[this.variantindex].show1=false
      this.rows[this.variantindex].show2=false
      this.rows[this.variantindex].priceqty=''
      //this.rows[this.variantindex].making_charges=0.00
      //this.rows[this.variantindex].selectcarat=null
      this.rows[this.variantindex].inclusive1=false
      this.rows[this.variantindex].err_qty=''
      this.rows[this.variantindex].err_price=0
      this.rows[this.variantindex].err_sgst=''
      this.rows[this.variantindex].err_cgst=''
      this.rows[this.variantindex].err_igst=''
      this.rows[this.variantindex].productExist=''
    }

    
  },
  checkShop(){
    if(!this.selectedcustomer){
      this.haserror.cust="Select Customer"
      this.barcode=''
    }else{
      this.haserror.cust=''
    }

    if(!this.selectshop){
      this.haserror.shop="Select Shop"
      this.barcode=''
    }else{
      this.haserror.shop=''
    }
  },

      // getSalePrice(prod,varnt,index){
      //   var _this = this
      //   console.log('get sale price')
      //   // console.log(this.rows[index])
      
      //   this.$http.get('/api/estshopinventories?filter[where][product_id]='+prod+'&filter[where][variant_id]='+varnt+'&filter[where][est_shop_id]='+_this.selectshop.est_shop_id).then(function (response){
      //       console.log(response)
      //       if(response.data!== null){
      //         if(response.data.exp_sellprice_bft !== '' && response.data.exp_sellprice_bft !== null)
      //         _this.rows[index]['price'] = parseFloat(response.data.exp_sellprice_bft).toFixed(3)
      //       _this.rows[index]['priceqty'] = parseFloat(response.data.exp_sellprice_bft).toFixed(3)
      //       }
      //       else{
      //         // if(_this.saleprice_editable === false){
      //           _this.saleprice_editable = true
      //           _this.saleprice_nonedit = false
      //           // _this.validatë = 0
      //           _this.rows[index]['price'] = '0.000'
      //           _this.row[index]['priceqty'] = '0.000 '
      //         // }
      //       }
      //   }).catch(function(er){
      //     console.log(er)
      //   })
      
      // },
      
      searchBarcode(){
        var option = {}
        var index = 0
        var addRow = 0
        var _this = this 
        var barcode = this.barcode
        this.barcode = ''
        if(barcode){
          this.$http.get('/api/purchasereturns/joinproduct2?barcode='+barcode).then(function (response) {
           
            var valueArr = _this.rows.map(item => item)
            var rowindex = -1
            var check =  valueArr.some(function(value,indx){
             
              if(value.selectproductrow == null){
                rowindex = indx
                
                return true }else {return false}
              })
            if(response.data[0] != null){
              
              if(_this.rows.length == 0 || rowindex == -1){
                rowindex = rowindex != -1 ? rowindex : _this.rows.length
                _this.rows.push({productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,caratval:[],selectcarat:null,stweightlist:[],selectstweight:null,weightlist:[],selectweight:null,making_charges:'',weight:'',netweight:'',wastage:'',stone_price:'',stone_weight:'',err_stone_weight:'',err_stone_price:'' ,price:0, qty:'',amt:'', cgst:0.00, sgst:0.00,igst:0.00,amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:0, is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',show:false,show1:false,show2:false})
              }
              _this.rows[rowindex].productnamex.push(response.data[0])
              _this.rows[rowindex].selectproductrow=response.data[0]
              _this.openvariant(response.data[0],rowindex)
            }  
            
          }).catch(function(error){
            console.log(error)
          })
        }
      },

      nameAndnumber (item) {
        return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`
      },
         //weight (item) {
        //return `${item.weight}`
      //},

        //stone_weight (item) {
        //return `${item.stone_weight}`
      //},
      
      purity_percentage(item){
        return `${item.purity_percentage}`
      },
      id(item){
        return `${item.id}`
      },

      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){
          
        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },
      
      onSelectCust(option1){

        this.haserror.cust = ''
        if(option1 === null)
          return
        console.log(option1)
        
        var _this = this
        this.customer_gst = null
        this.customer1.name = null
        this.customer1.add = null
        this.customer1.city = null
        this.customer1.state = null
        this.customer1.pincode = null
        this.customer1.phone = null
        this.customer1.gst = null
        this.customer1.ship_id = null
        this.addr.length = 0        
        this.$http.get('/api/customershippspecs?filter[where][customer_id]='+option1.customer_id).then(function(response){
          var addr_data = response.data['ship_dt']
          var state_dt = response.data['state_dt']
          var city_dt = response.data['city_dt']
          for (var i = 0; i < addr_data.length; i++) {
            if(parseInt(addr_data[i].shipp_id) === 1){
              _this.customer1.name =option1.cust_cmp_name
              _this.customer1.add = addr_data[i].address
              _this.customer1.city = city_dt[addr_data[i].city]
              _this.customer1.state = state_dt[addr_data[i].state_code]
              _this.customer1.pincode = addr_data[i].pincode
              _this.customer1.phone = addr_data[i].contact_no
              _this.customer1.gst = addr_data[i].gst_no
              _this.customer1.ship_id = addr_data[i].shipp_id
            }
            _this.addr.push({yname:addr_data[i].customer_name, yaddress:addr_data[i].address,ypincode:addr_data[i].pincode,ystate: state_dt[addr_data[i].state_code],ystateid:addr_data[i].state_code,ycityid:addr_data[i].city,ycity:city_dt[addr_data[i].city],yphn:addr_data[i].contact_no,chkship_id:addr_data[i].shipp_id,ygst:addr_data[i].gst_no})
          }
        })
        .catch(function(error){
          console.log(error)
        })
        //this.is_cs_gst = true
        //this.is_i_gst = true
        this.customer_gst = option1.cust_cmp_gst
        if(this.company_gst && this.customer_gst){
          var company_gst = this.company_gst.substring(0, 2)
          var customer_gst = this.customer_gst.substring(0, 2)  
          if(company_gst === customer_gst){
            //this.is_cs_gst = true
            //this.is_i_gst = false
            //this.csgstdisable = true
          }else{
           // this.is_cs_gst = false
           // this.is_i_gst = true
            //this.igstdisable = true
          }
        }else if(this.company_gst){
         // this.is_cs_gst = true
         // this.is_i_gst = true
          //this.csgstdisable = false
          //this.igstdisable = false
     }else if(!this.company_gst){
          //this.is_cs_gst = false
          //this.is_i_gst = false
        }
        if(this.rows.length > 0){
          this.set_taxforall()
           for (var i = 0; i < this.rows.length; i++) {
             if(this.rows[i].selectproductrow != null){
               if(this.rows[i].selectproductrow.tax_gst_id)
                 this.show_tax(this.rows[i],i)
            }
           }
        }
      },

  

      show_tax(temprow,index){
        var _this = this
        this.$http.get('/api/taxrates/findOne?filter[where][tax_id]='+temprow.selectproductrow.tax_gst_id).then(function(response){  
       console.log(response.data)
         if(_this.company_gst && _this.customer_gst){
        console.log(_this.company_gst + "  "+ _this.customer_gst)
          var company_gst = _this.company_gst.substring(0, 2)
          var customer_gst = _this.customer_gst.substring(0, 2)
          if(company_gst === customer_gst){   
            console.log(company_gst === customer_gst)     
            _this.rows[index]['cgst'] = response.data.tax_cgst
            _this.rows[index]['sgst'] = response.data.tax_sgst
            _this.rows[index]['igst'] = 0.00
          }else{
            _this.rows[index]['cgst'] = 0.00
            _this.rows[index]['sgst'] = 0.00
            _this.rows[index]['igst'] = response.data.tax_igst
          }
           _this.price(index)
        }
        else if(!_this.company_gst){
        //  _this.rows[index]['inclusive1'] = true
         console.log(_this.company_gst + "  "+ _this.customer_gst)
          _this.rows[index]['cgst'] = 0.00
          _this.rows[index]['sgst'] = 0.00
           _this.rows[index]['igst'] = 0.00
         // _this.rows[index]['igst'] = response.data.tax_igst
          _this.price(index)
        } else{
          //_this.rows[index]['inclusive1'] = false
           console.log("hiee",_this.company_gst)
          _this.rows[index]['cgst'] = response.data.tax_cgst 
          _this.rows[index]['sgst'] = response.data.tax_sgst
         _this.rows[index]['igst'] = ''
          _this.price(index)
        }
      }).catch(function(error){
       console.log(error)
      });
    },

   

 onSelectProduct(temprow,index){
      var _this = this
           var id = temprow.id
      this.$http.get('/api/estshopinventories?filter[where][id]='+id+'&filter[where][est_shop_id]='+this.selectshop.est_shop_id).then(function (response){
        console.log(response.data)
     console.log("qtyy",response.data[0].quantity)
      _this.rows[index]['avaqty']=response.data[0].quantity
        if(response.data[0].variant_value === null ){
          if(response.data.length!=0){      
           console.log("qtyy",response.data[1].quantity)
         
            //_this.rows[index]['selectcarat']=response.data[0].carat_value
             console.log(response.data[1].quantity)
                     _this.price(index)
              // _this.rows[index]['priceqty']=response.data[1].last_purprice_aft
             // _this.rows[index]['price'] = response.data[1].exp_sellprice_bft
              //_this.rows[index]['priceqty']=response.data[1].exp_sellprice_bft
              if(response.data[1].tax_inclusive==true){
                _this.rows[index]['inclusive1'] = true
              }else{
                _this.rows[index]['inclusive1'] = false
              }          
            }else{ 
             // _this.rows[index]['price']=0
             
              
            _this.rows[index]['avaqty']='0'
             
          
             console.log(response.data[0].quantity)
              _this.rows[index]['priceqty']=''
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
              _this.rows[index]['inclusive1'] = false
            }

            _this.rows[index]['variantrow'] ='n/a'
            _this.rows[index]['selectedproductid']='n/a';
            _this.rows[index]['show1'] = true
            _this.rows[index]['show']=false;
            _this.rows[index]['show2']=false;
            
            
          }else{
          _this.rows[index]['show']=true;
          _this.rows[index]['show1']=false
          _this.rows[index]['show2']=false
            if(response.data.length>1){
            if(response.data[1].tax_inclusive == true){ 
              _this.rows[index]['inclusive1'] = true
            }else{ 
              
              _this.rows[index]['inclusive1'] = false
            }
               
            //_this.rows[index]['selectedproductid']=response.data[0].variant_value;
            _this.rows[index]['avaqty']=response.data[1].quantity
              // _this.rows[index]['priceqty']=response.data[1].last_purprice_aft
            if(parseFloat(response.data[1].exp_sellprice_bft) == 0){
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
            }
           // _this.rows[index]['price']=response.data[1].exp_sellprice_bft
             //_this.rows[index]['making_charges']=0.00
            //_this.rows[index]['priceqty']=response.data[1].exp_sellprice_bft
              // if(_this.selectshop.saleprice === true){
              //    _this.saleprice_editable = true
              //    _this.saleprice_nonedit = false
              //  }
              //  else{
              //    _this.saleprice_nonedit = true
              //    _this.saleprice_editable = false
              //  }
              if(response.data[1].variant_id ==''){
                _this.rows[index]['variantrow'] ='n/a'
              }else{
                _this.rows[index]['variantrow']=response.data[1].variant_id
              }
            }
            else {
              _this.rows[index]['inclusive1'] = false
            
              //_this.rows[index]['priceqty'] = '0.000';
             // _this.rows[index]['price'] = '0.000';
              _this.rows[index]['inclusive1'] = false
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
            }
          }
          _this.price(index)
        }).catch(function(err){
          console.log(err)
        });
    },

//   onSelectProductAll(){
//     console.log('onselectproductall')
//     var _this = this
//     // console.log(temprow)
//     var lst_prod = []
//     var lst_var = []
//     for (var i = 0; i < this.rows.length; i++) {
//       if(this.rows[i].selectproductrow!==null){
//         lst_prod.push(this.rows[i].selectproductrow.product_id)
//         lst_var.push(this.rows[i].variantrow)
//       }
//     }
//     if(lst_prod.length > 0){
//     this.loading = true
//     this.$http.get('/api/estshopinventories?filter={"where": {"product_id": {"inq": ["'+ lst_prod.join('","')+'"]}, "variant_id": {"inq" : ["'+ lst_var.join('","') + '"]}, "est_shop_id": "' + this.selectshop.est_shop_id+'"}}').then(function (response){
//       console.log(response)
//       _this.loading = false
//       if(response.data.length > 0){
//           var prod_var = {}
//           console.log(response.data[0])
//           for(var k=0;k<response.data[0].length;k++){
//             prod_var[response.data[0][k]['product_id']] = response.data[0][k]['variant_id']
//           }
//           var inv_data = {}
//           for(var j=1;j<parseInt(response.data.length);j++){
//             let temp = {'avaqty': 0, 'price': 0, 'priceqty': 0}
//             temp['avaqty'] = response.data[j].quantity
//             temp['price'] = response.data[j].exp_sellprice_bft
//             temp['priceqty'] = response.data[j].exp_sellprice_bft
//             inv_data[response.data[j].product_id + '_' + response.data[j].variant_id] = temp
//           }

//           for(var i=0;i<_this.rows.length;i++){
//             var each = _this.rows[i]
//             let key = each.selectproductrow.product_id + '_' + each.variantrow
//             if(_this.rows[i].selectproductrow.product_id in prod_var){
//               _this.rows[i]['show'] = true;
//               _this.rows[i]['show1'] = false;
//               _this.rows[i]['show2'] = false;
              
//               // console.log(key)
//               if(key in inv_data){
//                 if(inv_data[key]['tax_inclusive'] === true){
//                   _this.rows[i]['inclusive1'] = true
//                 }
//                 else{
//                   _this.rows[i]['inclusive1'] = false
//                 }
//                 _this.rows[i]['selectedproductid']=prod_var[_this.rows[i].selectproductrow.product_id];
//                 _this.rows[i]['avaqty'] = inv_data[key]['avaqty'] 
//                 _this.rows[i]['price'] = inv_data[key]['price']
//                 _this.rows[i]['priceqty'] = inv_data[key]['priceqty']
//                 if(parseFloat(inv_data[key]['price']) === 0.0){
//                   _this.saleprice_editable = true
//                   _this.saleprice_nonedit = false
//                 }
//                 if(inv_data[key].variant_id == ''){
//                   _this.rows[i]['variantrow'] ='n/a'
//                 }else{
//                   _this.rows[i]['variantrow']=inv_data[key].variant_id
//                 }
//               }
//               else{
//                 _this.rows[i]['price']='0.000'
//                 _this.rows[i]['avaqty']='0'
//                 _this.rows[i]['priceqty']='0.000'
//                 _this.saleprice_editable = false
//                 _this.saleprice_nonedit = false
//               }
//             }
//             else{
//               if(key in inv_data){
//                 _this.rows[i]['avaqty']=inv_data[key]['avaqty']
//                 _this.rows[i]['price'] = inv_data[key]['price']
//                 _this.rows[i]['priceqty'] = inv_data[key]['priceqty']
//               }
//               else{
//                 _this.rows[i]['price']='0.000'
//                 _this.rows[i]['avaqty']='0'
//                 _this.rows[i]['priceqty']='0.000'
//                 _this.saleprice_editable = true
//                 _this.saleprice_nonedit = false
//               }
//               _this.rows[i]['variantrow'] ='n/a'
//               _this.rows[i]['selectedproductid']='n/a';
//               _this.rows[i]['show1'] = true
//               _this.rows[i]['show']=false;
//               _this.rows[i]['show2']=false;
//             }
//             _this.price(i)
//           }
//         }
//       }).catch(function(err){
//         console.log(err)
//         _this.loading = false
//       });
//     }
// },

setRow(temprow,index){
  var _this = this
  //var product_id = temprow.selectproductrow.product_id
  console.log(temprow.id)
  //var carat_value = temprow.selectcarat.carat_value
    this.$http.get('/api/estshopinventories?filter[where][id]='+temprow.id+'&filter[where][est_shop_id]='+this.selectshop.est_shop_id).then(function (response){
    console.log(response.data[0])
    console.log("below products")
    if(response.data.length > 0){
      _this.rows[index].selectproductrow.product_id= response.data[0].product_id
            _this.rows[index]['unit']=response.data[0].unit_name
            _this.rows[index]['unitvalue']=response.data[0].unit_id
               _this.rows[index]['avaqty']=response.data[0].quantity
             _this.rows[index]['selectedproductid']=response.data[0].product_id
             console.log( _this.rows[index])
            //_this.onSelectProduct(_this.rows[index],index)
            if(response.data[0].tax_gst_id !== '' && response.data[0].tax_gst_id !== null){
              _this.show_tax(_this.rows[index],index)
                 // _this.rows[index]['price']=response.data[0].product_unit_cost
                  _this.rows[index]['qty']=1
                  _this.rows[index]['unit']=response.data[0].unit_name
                  _this.rows[index]['unitvalue']=response.data[0].unit_id
                  _this.rows[index]['selectedproductid']=response.data[0].variant_id
                         _this.rows[index]['making_charges']=''
               _this.rows[index]['wastage']=''
                _this.rows[index]['stone_price']=''
                 _this.rows[index]['stone_weight']=''
                    _this.rows[index]['weight']=''
                _this.rows[index]['amttotal']=''
                _this.price(index)
          
               }else{
                 _this.rows[index]['amt']=''
                 _this.rows[index]['qty']=1
                 _this.rows[index]['cgst']=0.00
                 _this.rows[index]['sgst']=0.00
                 _this.rows[index]['igst']=0.00
                 _this.rows[index]['amttotal']=0
                 _this.rows[index]['inclusive1']=false
               }
             }

           }).catch(function (error) {
            console.log(error);
          });
           
         },

         onSelectvariant(option){
          var _this = this
          var index = this.variantindex
          // this.rows[this.variantindex].variantrow = option.variant_value
           if(option.variant_value === 'No Variant') {
              this.rows[this.variantindex]['variantrow']='n/a'
            }
            else{
              this.rows[this.variantindex]['variantrow']=option.variant_value
            }
          this.smallmodal=false;
          // var curr_prod = this.rows[this.variantindex]['selectproductrow']['product_id']
          // var curr_var = this.rows[this.variantindex]['variantrow']
          // if(this.lst_prod_var.length > 0){
          //   if(this.lst_prod_var.indexOf(curr_prod+'_'+curr_var) !== -1){
          //     alert('Item - ' + this.rows[this.variantindex]['selectproductrow']['product_name'] + ' with variant ' + option.variant_value + ' already added above. Kindly select other product')
          //       this.rows[this.variantindex]['selectproductrow']=null;
          //       this.rows[this.variantindex]['variantrow']=null
          //       return
          //   }
          // }
          // this.lst_prod_var[this.variantindex] = curr_prod+'_'+curr_var

          var temprow = this.rows[this.variantindex]
          // this.getSalePrice(this.rows[this.variantindex]['selectproductrow']['product_id'],option.variant_value,this.variantindex) 
          if(temprow.selectproductrow){
            this.setRow1(temprow, this.variantindex)
            console.log(this.variantindex)
          } 
          else{
            _this.rows[index]['selectedproductid']=''
            _this.rows[index]['unit']=''
            _this.rows[index]['unitvalue']=''
            _this.rows[index]['selectproductrow']=null
           // _this.rows[index]['price']=0
            _this.rows[index]['qty']=''
            _this.rows[index]['amt']=''
            _this.rows[index]['cgst']=0.00
            _this.rows[index]['sgst']=0.00
            _this.rows[index]['igst']=0.00
            _this.rows[index]['amttotal']=0
            _this.rows[index]['batchmd1']=''
            _this.rows[index]['serialmd1']=''
            _this.rows[index]['percentagemd1']=''
            _this.rows[index]['amtmd1']=''
            _this.rows[index]['variantrow']='n/a'
            _this.rows[index]['inclusive1']=false
            _this.rows[index]['salepricemd1']=0
          }
        },

        openvariant_on_product(row, index){
          if('product_id' in row.selectproductrow){
            this.openvariant(row,index)
          }
          else{
            return false
          }
        },
        
    openvariant(row,index){ 
               this.variantindex=index
               this.variantdata=null
               this.variantvalue=[]
               var _this = this
              var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id
    
        if(vrnt_id!=null  ) {
          this.rows[this.variantindex].novariant = true
          this.rows[this.variantindex].showvariant = false
          this.smallmodal=true;

          this.$http.get('/api/variantvalues?filter[where][variant_id]='+vrnt_id).then(function (response){
            _this.variantvalue=response.data
            _this.variantvalue.unshift({company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"})
          }).catch(function (error) {

          });
        }else{
          this.rows[this.variantindex].novariant = true
          this.rows[this.variantindex].showvariant = false
          var option = {company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"}
          this.onSelectvariant(option)
          this.smallmodal=false;
        }
      },

      openmodal(test){
        console.log("test"+ test)
        this.largeModal=true
        this.indexval=test
        this.percentagemd='';
        this.amtmd='';
        if(this.rows[test]['percentagemd1']!=''){
          this.percentagemd=this.rows[test].percentagemd1;
  
        }
        if(this.rows[test].amtmd1!=''){
          this.amtmd=this.rows[test].amtmd1;
        }
        this.inclusive=this.rows[test].inclusive1;
      },
      
      addRow1(){
        this.rows.push({ productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,caratval:[],stweightlist:[],selectstweight:null,selectcarat:null,weightlist:[],selectweight:null,making_charges:'',stone_price:'',stone_weight:'',weight:'',wastage:'',netweight:'',price:0, qty:'',amt:'',err_stone_weight:'',err_stone_price:'' , cgst:'', sgst:'',igst:'',amttotal:0,percentagemd1:'', amtmd1:'',avaqty:'',stprice:'',variantrow:'n/a',show:false,priceqty:'', inclusive1:false, err_qty:'', err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
      },
      removeElement: function(index) {
        this.rows.splice(index, 1);
        if(this.selected_pytype === 'partial'){
           this.bal = 0.0000
           this.totalparamtreceived = ''
         }
      },

      searchshops(shop_id){
        var _this = this
        this.$http.get('/api/shopusers/getShop').then(function (response) {
          _this.shopname = response.data
          if(shop_id === undefined){
            for (var i = 0; i < response.data.length; i++) {
              if(response.data.length == i+1){
                _this.selectshop = response.data[i]
                //if(_this.selectshop.saleprice === true){
                 // _this.saleprice_editable = true
                 // _this.saleprice_nonedit = false
               // }
               // else{
                 // _this.saleprice_nonedit = true
                 // _this.saleprice_editable = false
               // }
                _this.company_data();
              }
            }
          }
          else{
            var select_shp = _this.shopname.filter(function(each){
              return each.est_shop_id === shop_id
            });
            _this.selectshop = select_shp[0]
           // if(_this.selectshop.saleprice === true){
             // _this.saleprice_editable = true
              //_this.saleprice_nonedit = false
            //}
           // else{
             // _this.saleprice_nonedit = true
             // _this.saleprice_editable = false
            //}
            _this.company_data();
          }
        }).catch(function(er){
          console.log(er)
        })
      },

searchprd4(searchText, index) {
  this.haserror.cust = '';
  this.haserror.shop = '';
  this.haserror.prodct = '';
  let status = 1;

  // --- Validation ---
  if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
    status = 0;
    this.haserror.shop = "Please Select Shop";
  }
  if (this.selectedcustomer == null || this.selectedcustomer.customer_id === undefined) {
    status = 0;
    this.haserror.cust = "Please Select Customer";
  }

  // --- Proceed if valid ---
  if (status === 1 && searchText) {
    const _this = this;
    let query = `/api/purchasereturns/joinproduct2?data=${searchText}`;

    // --- Add category filter if available ---
    if (this.matchingCategories && this.matchingCategories.length > 0) {
      query += `&category_ids=${this.matchingCategories.join(',')}`;
    }

    console.log("Sales search query:", query);

    this.$http.get(query)
      .then(function (response) {
        _this.productnamexx = response.data;
        console.log("Sales product search response:", response.data);
      })
      .catch(function (error) {
        console.error("Error fetching sales products:", error);
      });
  }
},
      
        onSelectprd(option,index){
       //console.log("in proo index",index)
          this.selectproductrow1 = option
          var prodid = this.selectproductrow1.product_id
          console.log(this.selectproductrow1.product_name)
          console.log(this.selectproductrow1.product_id)
          this.searchlist(prodid,index)
      },

      searchlist(prdid,index){
          console.log(prdid)
          var pdid = prdid
          var _this=this      
          this.$http.get('/api/estshopinventories?filter[where][product_id]='+pdid+'&filter[where][est_shop_id]='+this.selectshop.est_shop_id).then(function (response){
          console.log("productname",response.data)
          //this.$http.get('api/Purities/puritydetails').then(function (response) {
          console.log(response.data)
           
          const temp = [];
          var tempres = response.data
          console.log(tempres)
       // in response.data index 0 is a observer(blank value getting displayed in drop down). To avaoid blank space for loop is used
         for (var i = 1; i < tempres.length; i++) {
           temp.push(tempres[i]);
            }
          console.log(temp)
          _this.products_list= temp
          
         
        }).catch(function (error) {
          console.log(error);  
        });
        
},
     onselectlist(option,index){
       //console.log("in carat index",index)
          var _this = this
          this.selectid = option
          console.log(this.selectid.id)
          console.log(this.selectid.product_unit_cost)
          _this.price1 = this.selectid.product_unit_cost
          _this.stone_weight1 = this.selectid.stone_weight
          _this.weight1 = this.selectid.weight
          _this.carat_value1 = this.selectid.carat_value
           _this.available_qty = this.selectid.quantity
           var carat = this.selectid.carat_value
           var prdslid = _this.selectid.id
           var prdid = _this.selectid.product_id
      },

        searchprd3(searchText,index,row){
        this.haserror.cust=''
        this.haserror.shop=''
        this.haserror.prodct=''
        var status = 1
          if(this.selectshop==null){
          status = 0
          this.haserror.shop="Please Select Shop"
        }
        if(this.selectedcustomer==null || this.selectedcustomer.customer_id === undefined){
          status = 0
          this.haserror.cust="Please Select customer"
        }
        if(this.selectshop==null || this.selectshop.est_shop_id === undefined){
          status = 0
          this.haserror.shop="Please Select Shop"
        }

        if(status == 1){
          var _this = this
          if(searchText){
            this.$http.get('/api/purchasereturns/joinproduct2?data='+searchText).then(function (response) {
            // checkVariant(index)
            row.productnamex=response.data
            console.log(response.data)
            
            
          }).catch(function (error) {
            console.log(error);  
          });}
        }
      },



      
      onShpChange(option){
        this.shop_option = option
        var item_exist = false;
        for (var i = 0; i < this.rows.length; i++) {
          if(this.rows[i].selectproductrow !== null){
            if(this.rows[i].selectproductrow.product_id !== null) {
              item_exist = true
              break;
            } 
          }
        }
        
        if(item_exist === true){
          this.shopchange_modal = true
        }
        else{
          // this.selectshop = this.select_shop
          this.onSelectShp()
        }
      },

      onSelectShp(){
        this.haserror.shop=''
        var option = this.shop_option
        this.company_gst = option.shop_gst
         this.onSelectCust(this.selectedcustomer);
        if(option.id != undefined){
          if(this.select_shop==null || this.select_shop.est_shop_id === undefined){
            this.haserror.shop="Please Select Shop"
          } 
        }else{
          this.haserror.shop="Please Select Shop"
        }
        this.selectshop = this.select_shop
         this.saleprice_editable = this.selectshop.saleprice
        //if(this.selectshop.saleprice === true){
        //  this.saleprice_editable = true
         // this.saleprice_nonedit = false
       // }
       // else{
         // this.saleprice_nonedit = true
         // this.saleprice_editable = false
        //}
        this.company_gst = option.shop_gst
         this.onSelectCust(this.selectedcustomer);
       // this.is_cs_gst = true
       // this.is_i_gst = true
       // if(this.company_gst && this.customer_gst){
          //var company_gst = this.company_gst.substring(0, 2)
          //var customer_gst = this.customer_gst.substring(0, 2)  
         // if(company_gst === customer_gst){
          //  this.is_cs_gst = true
           // this.is_i_gst = false
           // this.csgstdisable = true
        //  }else{
           // this.is_cs_gst = false
           // this.is_i_gst = true
           // this.igstdisable = true
         // }
       // }else if(this.company_gst){
         // this.is_cs_gst = true
        //  this.is_i_gst = true
          //this.csgstdisable = false
         // this.igstdisable = false
       // }else if(!this.company_gst){
          //this.is_cs_gst = false
          //this.is_i_gst = false
       // }
        this.totalamtreceived = '';
        this.rows.length = 0
        for (var i = 0; i <3; i++) {
          this.rows.push({ productnamex:[],caratval:[],selectcarat:null,selectedproductid:null,weightlist:[],selectweight:null,stweightlist:[],selectstweight:null, making_charges:'', stone_price:'',stone_weight:'',weight:'',netweight:'',wastage:'',unit:'',selectproductrow:null,price:0, qty:'',amt:'', cgst:0.00, sgst:0.00,igst:0.00,amttotal:0,percentagemd1:'', amtmd1:'',variantrow:'n/a',avaqty:'',stprice:'',show:false,priceqty:'', inclusive1:false, err_qty:'', err_stone_weight:'',err_stone_price:'' ,err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',show1:false,show2:false})
        }
      },

        
      onSelectcarat(option,index){
       //console.log("in carat index",index)
          this.haserror.cust=''
       this.selectcarat = option
       console.log(this.selectcarat.carat_value)
      this.searchweight(this.rows[index],index)
      //this.carat_price(this.rows[index],index)
       console.log(this.rows[index],index)
   
      },

      searchweight(temprow,index)
      {
        var _this=this  
       
        var id = temprow.product_id
        console.log(temprow.selectproductrow.product_id)
        //var carat = carat_value
        console.log(temprow)    
         //this.$http.get('/api/estshopinventories?filter[where][est_shop_id]='+this.selectshop.est_shop_id+'&filter[where][product_id]='+id).then(function (response){
       this.$http.get('/api/estshopinventories?filter[where][carat_value]='+this.selectcarat.carat_value+'&filter[where][est_shop_id]='+this.selectshop.est_shop_id+'&filter[where][product_id]='+temprow.selectproductrow.product_id).then(function (response){
         console.log("in search weight",response.data)
          _this.weightlist=response.data
          console.log(_this.weightlist)
        }).catch(function (error) {
          console.log(error);  
        });
          
      },

      onSelectweight(option2,index)
      {
        this.selectweight = option2.weight
        console.log(option2.carat_value)
        console.log(option2.weight)
        console.log(option2.stone_weight)
        var weight
        var stone_weight
        this.rows[index]['weight']=option2.weight
         this.rows[index]['stone_weight']=option2.stone_weight
         this.searchstweight(this.rows[index],index)
        //this.onSelectProduct(this.rows[index],index)
           
             
      },

  

    
       searchstweight(temprow)
      {
          var _this=this  
          console.log(temprow)    
          this.$http.get('/api/estshopinventories?filter[where][est_shop_id]='+this.selectshop.est_shop_id+'&filter[where][product_id]='+temprow.selectproductrow.product_id+'&filter[where][carat_value]='+temprow.selectcarat.carat_value+'&filter[where][weight]='+temprow.selectweight.weight).then(function (response){
           console.log("in search weight",response.data)
          _this.stweightlist=response.data
          console.log(_this.stweightlist)
        }).catch(function (error) {
          console.log(error);  
        });
          
      },

      onSelectstweight(option2,index)
      {
        this.selectstweight = option2.stone_weight
        console.log(option2.carat_value)
        console.log(option2.weight)
        console.log(option2.stone_price)
        var weight
        var stone_weight
        this.rows[index]['making_charges']=option2.making_charges
         this.rows[index]['wastage']=option2.wastage
        this.rows[index]['stone_weight']=option2.stone_weight
        this.rows[index]['stone_price']=option2.stone_price
        var ntweight = option2.netweight/option2.qty
        this.rows[index]['netweight']= parseFloat(ntweight).toFixed(2)
        this.onSelectProduct1(this.rows[index],index)
                 
      },


    
      searchcaratval(temprow){
        var _this=this
        var id =temprow.product_id     
        console.log (temprow.selectproductrow.product_id)
        this.$http.get('/api/estshopinventories?filter[where][est_shop_id]='+this.selectshop.est_shop_id+'&filter[where][product_id ]='+temprow.selectproductrow.product_id).then(function (response){
        //this.$http.get('api/Purities/puritydetails').then(function (response) {
          console.log(response.data)
          _this.caratval=response.data
        }).catch(function (error) {
          console.log(error);  
        });
          
      },
             
      searchcustomer(){
        var _this = this
        this.$http.get('/api/customers').then(function (response) {
          _this.customername = response.data
        }).catch(function (error) {
        });
      },

      savemodal(val,price){
       
        var num=/^([0-9]{1,2}|100)$/
        var num1=/^[0-9]{1,12}$/
        var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/

        this.haserror.amt=''
        this.haserror.dis=''
        
        if( this.percentagemd!='' && this.amtmd!=''){
          this.haserror.amt="Any one of required"
        }
        else if(this.percentagemd!='' &&  num.test(this.percentagemd)==false){
        this.haserror.dis="Please Provide Integer Between 1-100"                       
        }
        else if(this.amtmd!='' && amt_reg.test(this.amtmd)==false){
          this.haserror.amt="Please Provide Valid Amount"                      
        }
        else if(parseFloat(this.amtmd)>parseFloat(this.rows[val]['amt'])){
          this.haserror.amt="Discount Amount Cannot Be Greater Than Provided Amount"  
        }
        else{
          this.rows[val]['batchmd1']=this.batchmd
          this.rows[val]['serialmd1']=this.serialmd
          this.rows[val]['percentagemd1']=this.percentagemd
          this.rows[val]['amtmd1']=this.amtmd
          this.rows[val]['inclusive1']=this.inclusive
         
          this.largeModal=false;
          console.log(val+""+"value of val")
          this.price(val)
          console.log("VVVVV" + "" + val)
           console.log(val+""+"value of val")
          //this.making_charges(val);
        }
      },

      discountadd(){
        // console.log('discountadd')
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.addition)==false && this.detail.addition!='' ){
          this.detail.addition='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        this.err_totamtpay = '';
        if(parseFloat(this.detail.totalamtpay) < 0.00){
          // this.detail.addition='';
          this.err_totamtpay = 'Invalid Entry for Total Amount'
        }

        if(this.selected_pytype === 'partial'){
          if(this.totalparamtreceived !== ''){
            this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
          }inde
        }
        else if(this.selected_pytype === 'full'){
          this.totalamtreceived = parseFloat(this.detail.totalamtpay).toFixed(3)
        }
        // console.log(this.detail.totalamtpay)
      },

price(index, charge) {
  console.log(`[Price][Row ${index}] Starting calculation with charge: ${charge}, category: ${this.selectedCategoryType}`);

  // Validate charge
  if (charge === undefined || charge === null || typeof charge !== 'number' && isNaN(parseFloat(charge))) {
    console.warn(`[Price][Row ${index}] Invalid charge value: ${charge}. Using this.charge: ${this.charge}`);
    charge = parseFloat(this.charge) || 0;
  } else {
    charge = parseFloat(charge);
  }

  // Define regex patterns
  const priceRegex = /^\d{1,12}(\.\d{1,6})?$/;
  const taxRegex = /^[0-4]?[0-9]?(\.[0-9]{1,3})?$|^50$/;
  const igstRegex = /^[0-9]{0,2}(\.[0-9]{1,3})?$|^100$/;

  // IGST Validation
  if (this.rows[index]['igst'] && !igstRegex.test(this.rows[index]['igst'])) {
    this.rows[index]['igst'] = 0.00;
    this.rows[index]['err_igst'] = 'Invalid';
  } else if (parseFloat(this.rows[index]['igst']) < 0) {
    this.rows[index]['igst'] = 0.00;
    this.rows[index]['err_igst'] = 'Invalid';
  } else {
    this.rows[index]['err_igst'] = '';
  }

  // SGST Validation
  if (this.rows[index]['sgst'] && !taxRegex.test(this.rows[index]['sgst'])) {
    this.rows[index]['sgst'] = 0.00;
    this.rows[index]['err_sgst'] = 'Invalid';
  } else if (parseFloat(this.rows[index]['sgst']) < 0) {
    this.rows[index]['sgst'] = 0.00;
    this.rows[index]['err_sgst'] = 'Invalid';
  } else {
    this.rows[index]['err_sgst'] = '';
    this.rows[index]['cgst'] = this.rows[index]['sgst'];
    // When SGST and CGST are set, set IGST to 0
    if (parseFloat(this.rows[index]['sgst']) > 0) {
      this.rows[index]['igst'] = 0.00;
    }
  }

  // CGST Validation
  if (this.rows[index]['cgst'] && !taxRegex.test(this.rows[index]['cgst'])) {
    this.rows[index]['cgst'] = 0.00;
    this.rows[index]['err_cgst'] = 'Invalid';
  } else if (parseFloat(this.rows[index]['cgst']) < 0) {
    this.rows[index]['cgst'] = 0.00;
    this.rows[index]['err_cgst'] = 'Invalid';
  } else {
    this.rows[index]['err_cgst'] = '';
  }

  // Stone Weight Validation
  if (!this.rows[index].selectstweight) {
    this.rows[index]['err_stone_weight'] = '';
  } else if (parseFloat(this.rows[index].selectstweight) < 0) {
    this.rows[index]['err_stone_weight'] = 'Invalid Stone weight';
  } else if (!priceRegex.test(this.rows[index].selectstweight)) {
    this.rows[index]['err_stone_weight'] = 'Invalid stone weight';
  } else {
    this.rows[index]['err_stone_weight'] = '';
    this.rows[index].selectstweight = parseFloat(this.rows[index].selectstweight).toFixed(3);
  }

  // Default Wastage and Making Charges
  if (!this.rows[index]['wastage'] && this.rows[index]['stone_price'] && this.rows[index].selectstweight) {
    this.rows[index]['wastage'] = parseFloat(0).toFixed(3);
  }
  if (!this.rows[index]['making_charges'] && this.rows[index]['wastage'] && this.rows[index]['stone_price'] && this.rows[index].selectstweight) {
    this.rows[index]['making_charges'] = parseFloat(0).toFixed(3);
  }

  // Stone Price Validation
  if (!this.rows[index]['stone_price']) {
    this.rows[index]['err_stone_price'] = '';
  } else if (parseFloat(this.rows[index]['stone_price']) < 0) {
    this.rows[index]['err_stone_price'] = 'Invalid Stone price';
  } else if (!priceRegex.test(this.rows[index]['stone_price'])) {
    this.rows[index]['err_stone_price'] = 'Invalid stone price';
  } else {
    this.rows[index]['err_stone_price'] = '';
    this.rows[index]['stone_price'] = parseFloat(this.rows[index]['stone_price']).toFixed(3);
  }

  // Price Validation
  if (!this.rows[index]['price'] || isNaN(parseFloat(this.rows[index]['price'])) || typeof this.rows[index]['price'] !== 'string' && typeof this.rows[index]['price'] !== 'number') {
    console.warn(`[Price][Row ${index}] Invalid price value: ${this.rows[index]['price']}. Setting to charge: ${charge}`);
    this.rows[index]['err_price'] = 'Invalid';
    this.rows[index]['price'] = charge.toFixed(3);
  } else if (!priceRegex.test(this.rows[index]['price'])) {
    console.warn(`[Price][Row ${index}] Price fails regex validation: ${this.rows[index]['price']}. Setting to charge: ${charge}`);
    this.rows[index]['err_price'] = 'Invalid Price';
    this.rows[index]['price'] = charge.toFixed(3);
  } else {
    this.rows[index]['err_price'] = '';
    this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(3);
  }

  // Weight Validation
  if (!this.rows[index].selectweight) {
    this.rows[index]['err_weight'] = '';
  } else if (parseFloat(this.rows[index].selectweight) < 0) {
    this.rows[index]['err_weight'] = 'Invalid negative Weight';
  } else if (!priceRegex.test(this.rows[index].selectweight)) {
    this.rows[index]['err_weight'] = 'Invalid Weight';
  } else {
    this.rows[index]['err_weight'] = '';
    this.rows[index].selectweight = parseFloat(this.rows[index].selectweight).toFixed(3);
  }

  // Quantity Validation
  if (!this.rows[index]['qty']) {
    this.rows[index]['err_qty'] = 'Required';
  } else if (parseFloat(this.rows[index]['qty']) <= 0) {
    this.rows[index]['err_qty'] = 'Invalid Quantity';
  } else if (!priceRegex.test(this.rows[index]['qty'])) {
    this.rows[index]['err_qty'] = 'Invalid Quantity';
  } else {
    this.rows[index]['err_qty'] = '';
  }

  // Wastage Validation
  if (!this.rows[index]['wastage']) {
    this.rows[index]['err_wastage'] = '';
  } else if (parseFloat(this.rows[index]['wastage']) < 0) {
    this.rows[index]['err_wastage'] = 'Invalid wastage %';
  } else if (parseFloat(this.rows[index]['wastage']) > 100) {
    this.rows[index]['err_wastage'] = 'Invalid wastage %';
  } else if (!priceRegex.test(this.rows[index]['wastage'])) {
    this.rows[index]['err_wastage'] = 'Enter valid wastage';
  } else {
    this.rows[index]['err_wastage'] = '';
    this.rows[index]['wastage'] = parseFloat(this.rows[index]['wastage']).toFixed(3);
  }

  // Making Charges Validation
  if (!this.rows[index]['making_charges']) {
    this.rows[index]['err_making_charges'] = '';
  } else if (parseFloat(this.rows[index]['making_charges']) < 0) {
    this.rows[index]['err_making_charges'] = 'Invalid making charges';
  } else if (!priceRegex.test(this.rows[index]['making_charges'])) {
    this.rows[index]['err_making_charges'] = 'Invalid making charges';
  } else {
    this.rows[index]['err_making_charges'] = '';
    this.rows[index]['making_charges'] = parseFloat(this.rows[index]['making_charges']).toFixed(3);
  }

  // IGST Logic
  const igst_value = this.rows[index]['igst'] && parseFloat(this.rows[index]['igst']) > 0 ? parseFloat(this.rows[index]['igst']) : 0;

  // Price Calculation
  let total = 0;
  if (this.selectedCategoryType === 'silver') {
    if (this.silverInputMode === 'amount') {
      // Silver: Amount Mode
      if (!this.rows[index]['amt'] || isNaN(parseFloat(this.rows[index]['amt']))) {
        this.rows[index]['err_price'] = 'Required';
        total = 0;
      } else {
        this.rows[index]['err_price'] = '';
        total = parseFloat(this.rows[index]['amt']);
      }
    } else {
      // Silver: Price Mode
      const pricePerGram = parseFloat(this.rows[index]['price'] || charge || 0);
      const weight = parseFloat(this.rows[index].selectweight || 0);
      const qty = parseFloat(this.rows[index]['qty'] || 1);
      const makingCharges = parseFloat(this.rows[index]['making_charges'] || 0);

      console.log(`[Silver][Row ${index}] Price Mode Calculation Started`);
      console.log(`[Silver][Row ${index}] pricePerGram: ${pricePerGram}`);
      console.log(`[Silver][Row ${index}] weight: ${weight}`);
      console.log(`[Silver][Row ${index}] qty: ${qty}`);
      console.log(`[Silver][Row ${index}] makingCharges: ${makingCharges}`);

      if (pricePerGram > 0 && weight > 0 && qty > 0) {
        const makingChargesValue = makingCharges * weight * qty;
        const baseTotal = pricePerGram * weight * qty;
        total = (baseTotal + makingChargesValue);
        console.log(`[Silver][Row ${index}] total: ${total}`);
      } else {
        console.warn(`[Silver][Row ${index}] Invalid inputs. Setting total = 0`);
        total = 0;
      }
    }
  } else {
    // Gold (Non-Silver) Logic
    if (
      this.rows[index]['price'] &&
      this.rows[index]['qty'] &&
      this.rows[index].selectcarat &&
      this.rows[index]['wastage'] >= 0 &&
      this.rows[index].selectweight &&
      this.rows[index].selectstweight &&
      this.rows[index]['stone_price'] >= 0 &&
      this.rows[index]['making_charges'] >= 0
    ) {
      const price = parseFloat(this.rows[index]['price']);
      const stone_price = parseFloat(this.rows[index]['stone_price']);
      const making_charges = parseFloat(this.rows[index]['making_charges']);
      const qty = parseInt(this.rows[index]['qty']);
      const wastage = parseFloat(this.rows[index]['wastage']);
      const weight = parseFloat(this.rows[index].selectweight);
      const stone_weight = parseFloat(this.rows[index].selectstweight);

      this.rows[index]['netweight'] = parseFloat(weight + wastage - stone_weight).toFixed(3);
      const grossweight = parseFloat(this.rows[index]['netweight']);
      total = ((price * grossweight) + (making_charges * qty) + (stone_price * qty));
      console.log(`[Gold][Row ${index}] total: ${total}`);
    } else {
      this.rows[index]['netweight'] = parseFloat(0).toFixed(3);
      total = 0;
    }
  }

  // Discounts
  if (this.rows[index]['percentagemd1']) {
    total = total - (total * parseFloat(this.rows[index]['percentagemd1'])) / 100;
  }
  if (this.rows[index]['amtmd1']) {
    total = total - parseFloat(this.rows[index]['amtmd1']);
  }

  // Tax Calculation
  if (total) {
    if (!this.rows[index]['inclusive1']) {
      this.rows[index]['amt'] = total.toFixed(3);
      const amttotal = total + (total * parseFloat(this.rows[index]['sgst'] || 0) / 100) + (total * parseFloat(this.rows[index]['cgst'] || 0) / 100) + (total * igst_value / 100);
      this.rows[index]['amttotal'] = amttotal.toFixed(3);
      console.log(`[Tax][Row ${index}] amttotal: ${amttotal}`);
    } else {
      const amttotal = total.toFixed(3);
      this.rows[index]['amttotal'] = amttotal;
      const total_percentage = parseFloat(this.rows[index]['sgst'] || 0) + parseFloat(this.rows[index]['cgst'] || 0) + igst_value;
      const bfttotal = (total * (100 / (100 + total_percentage)));
      this.rows[index]['amt'] = bfttotal.toFixed(3);
    }
  }

  // Payment Handling
  if (this.selected_pytype === 'partial') {
    this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived || 0)).toFixed(3);
  } else if (this.selected_pytype === 'full') {
    this.totalamtreceived = parseFloat(this.totalamtpay).toFixed(3);
  }
},
        
        
        finalsubmit(val){ 
          var _thiss = this
          this.haserror.message=''
          this.haserror.cust='';
          this.haserror.shop='';
          var submit = 0
          _thiss.loading = true;
          // this.$http
          // .get("/api/saledetails/chk_plan_count")
          // .then(function (response) {
          //   // console.log(response.data.message)
          //   _thiss.loading = false;
          //   if ("message" in response.data) {
          //     if (response.data.message === true) {
          //       _thiss.plan_modal = true;
          //     } else {
                // _thiss.plan_modal = false;
                var num=/^[0-9]{1,11}$/
                var price = /^\d{1,12}(\.\d{1,6})?$/
                var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
                var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
                
                var submit = 0
                var dtregex=/^[0-9]{1}$/
                var saleentry_date = new Date(_thiss.saleentry_dt)
                var year1=saleentry_date.getFullYear()
                var month1=saleentry_date.getMonth()+1;
                var daycon=saleentry_date.getDate();

                if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
                if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

                saleentry_date=year1+'-'+month1+'-'+day1
                console.log(_thiss.rows)
                for (var i = _thiss.rows.length-1; i >=0;  i--) {
                  if(_thiss.rows[i].selectproductrow!=null){

                    if(_thiss.rows[i].price==''){
                    console.log(" price hi")
                      submit = 1
                      _thiss.rows[i].err_price = 'Required';
                    }else if(parseFloat(_thiss.rows[i].price)<0){
                      submit = 1
                      _thiss.rows[i].err_price = 'Invalid Price';
                    }else if(price.test(_thiss.rows[i].price)==false  && _thiss.rows[i].price!=''){
                      submit = 1
                      _thiss.rows[i].err_price = 'Invalid Price';
                    }
console.log(submit )
                // if(_thiss.saleprice_editable === true){
                //   if(_thiss.rows[i].salepricemd1==''){
                //       submit = 1
                //       _thiss.rows[i].err_saleprice = 'Required';
                //     }else if(parseFloat(_thiss.rows[i].salepricemd1)<0){
                //       submit = 1
                //       _thiss.rows[i].err_saleprice = 'Invalid Price';
                //     }else if(price.test(_thiss.rows[i].salepricemd1)==false  && _thiss.rows[i].salepricemd1!=''){
                //       submit = 1
                //       _thiss.rows[i].err_saleprice = 'Invalid Price';
                //     }
                //     else if(parseFloat(_thiss.rows[i].salepricemd1) < parseFloat(_thiss.rows[i].price)){
                //       submit = 1
                //       _thiss.rows[i].err_saleprice = 'Should be greater or equal to purchase price';
                //     }
                // }
console.log(submit )
                if(_thiss.rows[i].qty==''){
                  submit = 1
                  _thiss.rows[i].err_qty = 'Required';
                }else if(parseFloat(_thiss.rows[i].qty)<=0){
                  submit = 1
                  _thiss.rows[i].err_qty = 'Invalid Quantity';
                }

                      console.log(_thiss.rows[i]['weight'] )
                      
          if(_thiss.rows[i]['selectweight']==''){
            submit=1
          _thiss.rows[i]['err_weight'] = 'Invalid Weight';
         }else if(parseFloat(_thiss.rows[i]['selectweight'])<=0){
            
         _thiss.rows[i]['err_weight'] = 'Invalid weight';
        }else if(price.test(_thiss.rows[i]['selectweight'])==false  && _thiss.rows[i]['selectweight']!=''){
        
          _thiss.rows[i]['err_weight'] = 'Invalid weight';
        }else{
          
          _thiss.rows[i]['err_weight'] = '';
       
       }
console.log(submit )

           if(_thiss.rows[i]['wastage']==''){
              submit=1
          _thiss.rows[i]['err_wastage'] = 'Enter valid Wastage';
         }else if(parseFloat(_thiss.rows[i]['wastage'])<0.00){
        
         _thiss.rows[i]['err_wastage'] = 'Invalid wastage %';
         }else if(parseFloat(_thiss.rows[i]['wastage'])>100){
          
         _thiss.rows[i]['err_wastage'] = 'Invalid wastage %';
        }else if(price.test(_thiss.rows[i]['wastage'])==false  && _thiss.rows[i]['wastage']!=''){
          
          _thiss.rows[i]['err_wastage'] = 'Enter valid Wastage';
        }else{
        
          _thiss.rows[i]['err_wastage'] = '';
          _thiss.rows[i]['wastage'] = parseFloat(_thiss.rows[i]['wastage']).toFixed(3)
       }


console.log(submit )
                           
          if(_thiss.rows[i]['stone_price']==''){
              submit=1
          _thiss.rows[i]['err_stone_price'] = 'Invalid Stone price';
         }else if(parseFloat(_thiss.rows[i]['stone_price'])<0){
            
         _thiss.rows[i]['err_stone_price'] = 'Invalid Stone price';
        }else if(price.test(_thiss.rows[i]['stone_price'])==false  && _thiss.rows[i]['stone_price']!=''){
            
          _thiss.rows[i]['err_stone_price'] = 'Invalid Stone price';
        }else{
            
          _thiss.rows[i]['err_stone_price'] = '';
       
       }
console.log(submit )
                            
          if(_thiss.rows[i]['selectstweight']==''){
        submit=1
          _thiss.rows[i]['err_stone_weight'] = 'Invalid Stone price';
         }else if(parseFloat(_thiss.rows[i]['selectstweight'])<0){
 
         _thiss.rows[i]['err_stone_weight'] = 'Invalid Stone price';
        }else{
         
          _thiss.rows[i]['err_stone_weight'] = '';
       
       }
console.log(submit )


                if(parseFloat(_thiss.rows[i].making_charges)<0){
               submit=1
                  _thiss.rows[i].err_making_charges = 'Invalid making charges';
                }else if(price.test(_thiss.rows[i].making_charges)==false  && _thiss.rows[i].making_charges != ''){
          
                  _thiss.rows[i]['err.making_charges'] = 'Invalid making charges';
                }else {

                       _thiss.rows[i]['err_making_charges'] = '';
                }
console.log(submit )
                if(igstexp.test(_thiss.rows[i]['igst'])==false && _thiss.rows[i]['igst']!=''){
                  _thiss.rows[i]['igst']=''
                  _thiss.rows[i]['err_igst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(_thiss.rows[i]['igst'])<0){
                  _thiss.rows[i]['igst']=''
                  _thiss.rows[i]['err_igst'] = 'Invalid';
                  submit = 1
                }
console.log(submit )
                if(tax.test(_thiss.rows[i]['cgst'])==false  && _thiss.rows[i]['cgst']!=0){
                  _thiss.rows[i]['cgst']=0
                  _thiss.rows[i]['err_cgst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(_thiss.rows[i]['cgst'])<0){
                  _thiss.rows[i]['cgst']=0
                  _thiss.rows[i]['err_cgst'] = 'Invalid';
                  submit = 1
                }
console.log(submit )
                if(tax.test(_thiss.rows[i]['sgst'])==false  && _thiss.rows[i]['sgst']!=0){
                  _thiss.rows[i]['sgst']=0
                  _thiss.rows[i]['err_sgst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(_thiss.rows[i]['sgst'])<0){
                  _thiss.rows[i]['sgst']=0
                  _thiss.rows[i]['err_sgst'] = 'Invalid';
                  submit = 1
                }

              }
            }
  console.log("end" )
            if(_thiss.selectedcustomer==null || _thiss.selectedcustomer.customer_id==null || _thiss.selectshop==null || _thiss.selectshop.est_shop_id==null){
              if(_thiss.selectshop==null || _thiss.selectshop.est_shop_id==null){
                _thiss.haserror.shop="Please Select Shop"
                 _thiss.loading = false;
                
              }
              if(_thiss.selectedcustomer==null || _thiss.selectedcustomer.customer_id==null){
                _thiss.haserror.cust="Please Select Customer"
                 _thiss.loading = false;
              }
            }else{
              for (var i = _thiss.rows.length-1; i >=0;  i--) {
                if(_thiss.rows[i].selectproductrow==null){
                  _thiss.rows.splice(i,1);
                }
              }
              _thiss.err_totamtpay = '';
              if(_thiss.rows.length==0){
                alert("nothing to Save");
                _thiss.loading = false;
              }else{
                var _this=_thiss
                if(parseFloat(_thiss.detail.totalamtpay) < 0){
                  _thiss.err_totamtpay = 'Invalid Entry for Total Amount'
                }
                else{
                  if(submit == 0){
                  _thiss.amt_rec = ''
                  if(_thiss.selected_pytype === 'full'){
                    if(parseFloat(_thiss.chng) < 0.00){
                      _thiss.amt_rec = 'Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)'
                      _thiss.totalamtreceived = ''
                      _thiss.chng = 0
                      return
                    }
                    _thiss.detail.totalamtpendingpay = 0
                 
                  }
                   
                  else if(_thiss.selected_pytype === 'partial'){
        
                    if(parseFloat(_thiss.totalparamtreceived) == 0 || _thiss.totalparamtreceived == ''){
                      _thiss.amt_rec = 'Required'
                      _thiss.totalparamtreceived = ''
                      _thiss.bal = 0.0000
                      return                  
                    }else if(parseFloat(_thiss.bal) < 0){
                      _thiss.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)'
                      _thiss.totalparamtreceived = ''
                      _thiss.bal = 0.0000
                      return
                    }
                    _thiss.detail.totalamtpendingpay = _thiss.bal
                  }
                  else{
                  _thiss.detail.totalamtpendingpay = _thiss.detail.totalamtpay 
                }
  
                if(_thiss.cheque_date != ''){
                  var daynum = /^[0-9]{1}$/
                  let date = new Date(_thiss.cheque_date)
                  var year = date.getFullYear()
                  var month = date.getMonth()+1;
                  var day = date.getDate();

                  if(daynum.test(month)==true){
                    var month='0'+month
                  }else{
                    var month=month
                  }

                  if(daynum.test(day)==true){
                    var day='0'+day
                  }else{
                    var day=day
                  }
                  var dateval = year+'-'+month+'-'+day
                }else{
                  var dateval = null
                }
          
                _thiss.loading=true
       
                var data={}
                data.sale_entry_date=saleentry_date
                data.suppliersid=_thiss.selectedcustomer.customer_id
                data.shopid=_thiss.selectshop.est_shop_id
                data.ship_id=_thiss.customer1.ship_id
                data.pur_items=_thiss.rows
                data.total_discount=_thiss.detail.totprddis
                data.additional=_thiss.detail.addition
                data.amt_before_tax=_thiss.detail.tot
                data.cgst=_thiss.detail.cgst
                data.sgst=_thiss.detail.sgst
                data.igst=_thiss.detail.igst
                data.taxamt=_thiss.detail.taxamt
                data.totalamtpay=_thiss.detail.totalamtpay
                data.totalamtpendingpay = _thiss.detail.totalamtpendingpay
                data.pay = {'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0}
                data.pay.paytype = _thiss.selected_pytype
                data.pay.paymode = _thiss.selected_pymode
                data.pay.chqno = _thiss.cheque_no
                data.pay.chqdt = dateval
                data.pay.amt = parseFloat(_thiss.detail.totalamtpay) - parseFloat(_thiss.detail.totalamtpendingpay)
                data.carat_value = _thiss.carat_value
                data.charges = this.making_charges
                data.purchase_prc = _thiss.purchase_prc
                console.log("testingg",_thiss.purchase_prc)
               
                console.log("finalsubmit",data.pur_items)
                
      
                _thiss.$http.post('/api/sales/saledata', data).then(function (response) {
                  if(response.data.data.status_Code == 200){
                  var saleid = response.data.data.sale;
                  //console.log(response.data)
                    //console.log(response.data.data)
                          console.log(response.data.data.sale)
                  _this.loading=false;
                  document.body.scrollTop = 0;
                  document.documentElement.scrollTop = 0;
                  _this.haserror.message= 'Sales Added Successfully';
                  setTimeout(function(){ _this.haserror.message='';}, 2000);
                  
                  if(val == 'inv'){ 
                      // _this.$router.props=[saleid,_this.suppliersid]
                        // _this.$router.push('/saleinvoice/saleinvoicepdf')
                        let routeData = _thiss.$router.resolve({name: 'Sale Invoice Pdf', query: {sid: saleid,cid:_thiss.selectedcustomer.customer_id}});
                        window.open(routeData.href, '_blank');
                      }
                      _this.reset()
                  } else if(response.data.data.status_Code == 401){
                    _this.loading =false;
                  _this.haserror.message= 'Something Went Wrong While Adding Sales';
                  setTimeout(function(){ _thiss.haserror.message='';}, 3000);
                }
                }).catch(function (error) {
                  console.log('error ' + error)
                  _this.loading=false
                });
              }
            }
          }
        }
  // }
  // } else {
  //   console.log("something went wrong");
  //   }
  // })
  // .catch(function (error) {
  //   _thiss.loading = false
  //   console.log(error);
  // });
},
reset(){
  this.igstdisable=true
  this.csgstdisable=true
  this.selectedcustomer=null
  this.selectshop=null
  this.selectcarat=null
  this.selectweight=null
  this.making_charges=''
  this.weight=''
  this.netweight=''
  this.wastage=''
  this.stone_price=''
  this.stone_weight=''
  this.select_shop=null
  this.detail.totprddis=''
  this.detail.addition=''
  this.detail.tot=''
  this.detail.cgst=''
  this.detail.sgst=
  this.detail.igst=''
  this.detail.taxamt=''
  this.detail.totalamtpay=''
  this.detail.totalamtpendingpay=''
  this.chng=0
  this.bal=0.0000
  this.totalamtreceived=''
  this.cheque_no=''
  this.cheque_date=''
  this.addr=[]
  this.company_gst=null
  this.customer_gst=null
  this.selected_pymode='cash'
  this.selected_pytype='full'
  this.customer1.name = null
  this.customer1.add = null
  this.customer1.city = null
  this.customer1.state = null
  this.customer1.pincode = null
  this.customer1.phone = null
  this.customer1.gst = null
  this.customer1.ship_id = null
  this.saleentry_dt = new Date().toISOString().slice(0,10)
  for (var i = this.rows.length-1; i >=0;  i--) {
    this.rows.splice(i,1);
  }
  for (var i = 0; i <=2; i++){
   this.rows.push({ caratval:[],selectcarat:null,weightlist:[],selectweight:null,stweightlist:[],selectstweight:null,making_charges:'',weight:'',netweight:'',wastage:'',stone_price:'',stone_weight:'',err_stone_weight:'',err_stone_price:'' ,productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:0, qty:'',amt:'', cgst:0.00, sgst:0.00,igst:0.00,amttotal:0,percentagemd1:'', amtmd1:'',variantrow:'n/a',avaqty:'',stprice:'',show:false,show1:false,show2:false,priceqty:'', inclusive1:false,err_qty:'', err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
 }
}
}
}
</script>
<style>
  .modal-title{
    color:black;
    font-weight:bold;
  }
</style>


// WEBPACK FOOTER //
// src/views/sales/addsales.vue